import MobileMenu, { MobileMenuCSS } from "./MobileMenu";
import { supabase } from "./supabaseClient";
import { useState, useEffect, useRef } from "react";
import { useToast, ToastContainer, LineSkeleton } from "./toast";

// --- REAL MICHIGAN LEGISLATORS DATA ---

const SENATORS = [
  { id:"s1",  chamber:"Senate", district:1,  name:"Erika Geiss",        party:"D", region:"Taylor / Downriver",       committees:["Education (Chair)","Economic & Community Dev.","Health Policy","Housing & Human Services","Oversight"],       ideology:3, keyIssues:["Education funding","Civil rights","Labor protections"],         bio:"Progressive voice from Wayne County. Strong labor and education advocate with deep community ties in Downriver communities." },
  { id:"s2",  chamber:"Senate", district:2,  name:"Sylvia Santana",     party:"D", region:"Detroit",                  committees:["Appropriations","Civil Rights, Judiciary & Public Safety","Elections & Ethics","Health Policy (Vice Chair)","Housing & Human Services (Vice Chair)","Regulatory Affairs"],                            ideology:2, keyIssues:["Healthcare access","Detroit revitalization","Housing"],         bio:"Detroit-based senator focused on healthcare equity and urban investment. Reliable Democratic vote on social policy." },
  { id:"s3",  chamber:"Senate", district:3,  name:"Stephanie Chang",    party:"D", region:"Detroit",                  committees:["Civil Rights, Judiciary & Public Safety (Chair)","Education","Elections & Ethics","Energy & Environment","Housing & Human Services"],                ideology:2, keyIssues:["Environmental justice","Criminal justice reform","Clean energy"], bio:"Environmental justice champion. Former House member with broad policy expertise, especially on climate and criminal justice." },
  { id:"s4",  chamber:"Senate", district:4,  name:"Darrin Camilleri",   party:"D", region:"Brownstown / Rockwood",    committees:["Appropriations","Energy & Environment","Finance, Insurance & Consumer Protection","Labor (Vice Chair)","PreK-12 Appropriations (Chair)"],                        ideology:4, keyIssues:["Labor rights","Education","Working families"],                  bio:"Labor-focused senator from a competitive suburban district. Former teacher and staunch union advocate." },
  { id:"s5",  chamber:"Senate", district:5,  name:"Dayna Polehanki",    party:"D", region:"Livonia / Westland",       committees:["Education (Chair)","Economic & Community Dev.","Energy & Environment","Natural Resources & Agriculture","Oversight","Regulatory Affairs (Vice Chair)"],                              ideology:5, keyIssues:["Education","Local governance","Women's rights"],               bio:"Moderate Democrat from suburban Wayne County. Education-focused with strong constituent services record." },
  { id:"s6",  chamber:"Senate", district:6,  name:"Mary Cavanagh",      party:"D", region:"Redford / Dearborn Heights",committees:["Finance, Insurance & Consumer Protection (Chair)","Appropriations","Economic & Community Dev. (Vice Chair)","Housing & Human Services","Labor","LARA/DIFS Appropriations (Chair)","LEO/MEDC Appropriations (Chair)"],                                    ideology:4, keyIssues:["Public safety","Consumer protection","Budget"],                bio:"Pragmatic Democrat from a heavily populated district. Focus on fiscal responsibility and public safety." },
  { id:"s7",  chamber:"Senate", district:7,  name:"Jeremy Moss",        party:"D", region:"Southfield",               committees:["Elections & Ethics (Chair)","Regulatory Affairs (Chair)","Economic & Community Dev.","Government Operations","Local Government"],                  ideology:3, keyIssues:["LGBTQ+ rights","Tax policy","Financial regulation"],            bio:"President Pro Tem. Progressive Southfield senator and leading LGBTQ+ rights voice in the legislature." },
  { id:"s8",  chamber:"Senate", district:8,  name:"Mallory McMorrow",   party:"D", region:"Royal Oak / Troy",         committees:["Economic & Community Dev. (Chair)","Appropriations","Elections & Ethics","JCAR","Oversight (Vice Chair)"],                     ideology:4, keyIssues:["Infrastructure","Transit","Tech economy","LGBTQ+ rights"],     bio:"High-profile Democrat known for viral floor speech on LGBTQ+ rights. Suburban Oakland County moderate with national profile." },
  { id:"s9",  chamber:"Senate", district:9,  name:"Michael Webber",     party:"R", region:"Rochester Hills",          committees:["Economic & Community Dev.","Health Policy (Vice Chair)"],     ideology:7, keyIssues:["Small business","Lower taxes","Healthcare cost"],              bio:"Rochester Hills Republican focused on small business and economic development. Moderate within GOP caucus." },
  { id:"s10", chamber:"Senate", district:10, name:"Paul Wojno",         party:"D", region:"Warren",                   committees:["Elections & Ethics (Vice Chair)","Civil Rights, Judiciary & Public Safety","Health Policy","JCAR","Local Government (Vice Chair)","Regulatory Affairs"],                                 ideology:4, keyIssues:["Labor rights","Manufacturing","Regulatory balance"],           bio:"Warren-based senator with strong labor ties. Represents a heavily union Macomb County district." },
  { id:"s11", chamber:"Senate", district:11, name:"Veronica Klinefelt", party:"D", region:"Eastpointe / St. Clair Shores",committees:["Local Government (Chair)","Veterans & Emergency Services (Chair)","Appropriations","Health Policy","Transportation Appropriations (Chair)"],                   ideology:5, keyIssues:["Infrastructure","Local government funding","Fiscal policy"],  bio:"Pragmatic Democrat focused on funding local governments and infrastructure in the Macomb/Wayne area." },
  { id:"s12", chamber:"Senate", district:12, name:"Kevin Hertel",       party:"D", region:"St. Clair Shores / Clinton Twp",committees:["Health Policy (Chair)","Appropriations","Energy & Environment","Veterans & Emergency Services (Vice Chair)","Military/Veterans/State Police Appropriations (Chair)"],                          ideology:5, keyIssues:["Transportation","Criminal justice","Constituent services"],   bio:"Macomb County Democrat with strong constituent services record. Works across the aisle on transportation issues." },
  { id:"s13", chamber:"Senate", district:13, name:"Rosemary Bayer",     party:"D", region:"Beverly Hills / Clawson",  committees:["Appropriations - MDE (Vice Chair)","Appropriations - MiLEAP (Vice Chair)","Energy & Environment","Finance, Insurance & Consumer Protection","Housing & Human Services","JCAR (Vice Chair)","Local Government","Natural Resources & Agriculture"],                ideology:4, keyIssues:["Environment","Water quality","Fiscal accountability"],        bio:"Oakland County Democrat with focus on environmental protection and PFAS cleanup. Data-driven legislator." },
  { id:"s14", chamber:"Senate", district:14, name:"Sue Shink",          party:"D", region:"Ann Arbor area",           committees:["Natural Resources & Agriculture (Chair)","Civil Rights, Judiciary & Public Safety (Vice Chair)","Appropriations - Corrections & Judiciary (Chair)","Appropriations - EGLE (Vice Chair)","Housing & Human Services","Labor","Local Government"],               ideology:3, keyIssues:["Environmental law","Clean water","Criminal justice"],          bio:"Environmental attorney turned senator. Strong progressive on climate and judicial reform." },
  { id:"s15", chamber:"Senate", district:15, name:"Jeff Irwin",         party:"D", region:"Ann Arbor",                committees:["Housing & Human Services (Chair)","Civil Rights, Judiciary & Public Safety","Education","Finance, Insurance & Consumer Protection (Vice Chair)","Appropriations - EGLE (Chair)"],                                ideology:2, keyIssues:["Higher education","Tax policy","Civil liberties"],             bio:"Ann Arbor progressive with deep policy expertise. Former longtime House member who brings legislative experience to the Senate." },
  { id:"s16", chamber:"Senate", district:16, name:"Joseph Bellino",     party:"R", region:"Monroe",                   committees:["Energy & Environment","Regulatory Affairs","Transportation & Infrastructure (Vice Chair)","Veterans & Emergency Services"],                     ideology:7, keyIssues:["Transportation","Economic development","Law enforcement"],    bio:"Monroe County Republican. Former mayor with focus on transportation infrastructure and law enforcement support." },
  { id:"s17", chamber:"Senate", district:17, name:"Jonathan Lindsey",   party:"R", region:"Jackson area",             committees:["Housing & Human Services (Minority Vice Chair)","Economic & Community Dev.","Natural Resources & Agriculture","Oversight"],                           ideology:8, keyIssues:["Agriculture","Rural issues","Property rights"],               bio:"Rural conservative focused on agricultural policy and property rights. Consistent Republican vote on most issues." },
  { id:"s18", chamber:"Senate", district:18, name:"Thomas Albert",      party:"R", region:"Lowell / Ionia area",      committees:["Appropriations","Labor (Minority Vice Chair)"],                                  ideology:8, keyIssues:["Fiscal responsibility","Budget","Tax cuts"],                  bio:"Former House Appropriations chair now in Senate. Strong fiscal conservative with deep budget expertise." },
  { id:"s19", chamber:"Senate", district:19, name:"Sean McCann",        party:"D", region:"Kalamazoo",                committees:["Energy & Environment (Chair)","Appropriations (Vice Chair)","Finance, Insurance & Consumer Protection","Joint Capital Outlay Appropriations (Chair)","Universities & Community Colleges Appropriations (Chair)"],                            ideology:4, keyIssues:["Healthcare","Appropriations","Housing"],                      bio:"Kalamazoo Democrat with healthcare focus. Serves on Appropriations and understands budget mechanics well." },
  { id:"s20", chamber:"Senate", district:20, name:"Aric Nesbitt",       party:"R", region:"Porter Township",          committees:["Government Operations (Minority Vice Chair)"],                               ideology:9, keyIssues:["Deregulation","Tax cuts","Business climate"],                bio:"Minority Leader. Strong conservative from Southwest Michigan. Consistent opposition to Democratic agenda; key vote-counter for GOP." },
  { id:"s21", chamber:"Senate", district:21, name:"Sarah Anthony",      party:"D", region:"Lansing",                  committees:["Appropriations (Chair)","Government Operations","General Government Appropriations (Chair)"],                         ideology:3, keyIssues:["State budget","Community investment","Equity"],               bio:"Lansing Democrat with appropriations expertise. Focuses on equitable budget allocations and community investment." },
  { id:"s22", chamber:"Senate", district:22, name:"Lana Theis",         party:"R", region:"Brighton",                 committees:["Appropriations","Finance, Insurance & Consumer Protection","JCAR (Minority Vice Chair)"],                                 ideology:8, keyIssues:["School choice","Parental rights","Education reform"],         bio:"Livingston County conservative. Education traditionalist focused on school choice and parental rights. Active on social issues." },
  { id:"s23", chamber:"Senate", district:23, name:"Jim Runestad",       party:"R", region:"White Lake / Commerce Twp",committees:["Civil Rights, Judiciary & Public Safety (Minority Vice Chair)","Health Policy","JCAR"],                            ideology:8, keyIssues:["Criminal justice","Deregulation","Property rights"],         bio:"Oakland County Republican. Strong on criminal justice from a law enforcement perspective. Skeptical of regulatory expansion." },
  { id:"s24", chamber:"Senate", district:24, name:"Ruth Johnson",       party:"R", region:"Holly / Clarkston area",   committees:["Civil Rights, Judiciary & Public Safety","Education (Minority Vice Chair)","Elections & Ethics (Minority Vice Chair)"],                              ideology:7, keyIssues:["Election integrity","Local governance","Taxes"],              bio:"Former Secretary of State. Election integrity focus. Moderate Republican with statewide credentials." },
  { id:"s25", chamber:"Senate", district:25, name:"Dan Lauwers",        party:"R", region:"Thumb / Sanilac area",     committees:["Government Operations","Energy & Environment (Minority Vice Chair)","Natural Resources & Agriculture"],                           ideology:8, keyIssues:["Agriculture","Natural resources","Rural economy"],            bio:"Thumb region conservative. Deep agricultural roots; reliable Republican vote on farm and rural issues." },
  { id:"s26", chamber:"Senate", district:26, name:"Kevin Daley",        party:"R", region:"Lapeer / Tuscola",         committees:["Finance, Insurance & Consumer Protection","Local Government","Natural Resources & Agriculture (Minority Vice Chair)"],                               ideology:8, keyIssues:["Agriculture","Rural roads","Property rights"],               bio:"Rural Republican from the Thumb. Agriculture and transportation focus; votes with GOP caucus consistently." },
  { id:"s27", chamber:"Senate", district:27, name:"John Cherry",        party:"D", region:"Flint / Genesee",          committees:["Labor (Chair)","Appropriations","Agriculture & Natural Resources Appropriations (Chair)","General Government Appropriations (Vice Chair)","Health Policy","Housing & Human Services","Natural Resources & Agriculture (Vice Chair)"],                     ideology:4, keyIssues:["Flint recovery","Economic development","Water infrastructure"],bio:"Genesee County Democrat. Focused on Flint's continued recovery and regional economic development." },
  { id:"s28", chamber:"Senate", district:28, name:"Sam Singh",          party:"D", region:"East Lansing / Meridian",  committees:["Oversight (Chair)","Energy & Environment (Vice Chair)","Government Operations (Vice Chair)","Natural Resources & Agriculture","Regulatory Affairs"],                     ideology:4, keyIssues:["University funding","Tech economy","Tax policy"],             bio:"East Lansing Democrat with strong higher education and technology focus. Moderate on fiscal issues." },
  { id:"s29", chamber:"Senate", district:29, name:"Winnie Brinks",      party:"D", region:"Grand Rapids",             committees:["Government Operations (Chair)","Appropriations"],                                  ideology:4, keyIssues:["Budget","Healthcare","Urban investment"],                     bio:"Senate Majority Leader. Grand Rapids Democrat navigating a competitive urban district. Pragmatic coalition-builder." },
  { id:"s30", chamber:"Senate", district:30, name:"Mark Huizenga",      party:"R", region:"Walker / Wyoming area",    committees:["Appropriations","Finance, Insurance & Consumer Protection (Minority Vice Chair)","Health Policy"],                                       ideology:7, keyIssues:["Fiscal policy","Insurance reform","Business"],                bio:"West Michigan Republican. Finance focus and business-friendly. Moderate within GOP — sometimes a swing vote on fiscal matters." },
  { id:"s31", chamber:"Senate", district:31, name:"Roger Victory",      party:"R", region:"West Michigan / Ottawa",   committees:["Economic & Community Dev. (Minority Vice Chair)","Natural Resources & Agriculture","Transportation & Infrastructure"],                           ideology:8, keyIssues:["Agriculture","Water rights","Rural economy"],                bio:"Ottawa County Republican. Strong agricultural policy focus. Consistently conservative on most votes." },
  { id:"s32", chamber:"Senate", district:32, name:"Jon Bumstead",       party:"R", region:"Newaygo / Muskegon area",  committees:["Appropriations (Minority Vice Chair)","Transportation & Infrastructure"],          ideology:7, keyIssues:["Natural resources","Fishing","Rural infrastructure"],        bio:"West Michigan Republican with strong natural resource and fishing industry ties." },
  { id:"s33", chamber:"Senate", district:33, name:"Rick Outman",        party:"R", region:"Six Lakes / Montcalm",     committees:["Appropriations","Energy & Environment","Transportation & Infrastructure"],                           ideology:9, keyIssues:["Deregulation","Agriculture","Small government"],             bio:"Very conservative rural Republican. Strong deregulation advocate and consistent GOP caucus vote." },
  { id:"s34", chamber:"Senate", district:34, name:"Roger Hauck",        party:"R", region:"Isabella / Clare area",    committees:["Regulatory Affairs (Minority Vice Chair)","Energy & Environment","Health Policy"],                                ideology:8, keyIssues:["Energy policy","Natural resources","Rural economy"],         bio:"Mid-Michigan Republican with energy and natural resources focus. Reliable conservative vote." },
  { id:"s35", chamber:"Senate", district:35, name:"[Vacant]",           party:"-", region:"Mid-Michigan",             committees:[],                                                           ideology:5, keyIssues:[],                                                           bio:"Seat currently vacant." },
  { id:"s36", chamber:"Senate", district:36, name:"Michele Hoitenga",   party:"R", region:"Manton / Cadillac area",   committees:["Housing & Human Services","Local Government (Minority Vice Chair)","Natural Resources & Agriculture"],                          ideology:8, keyIssues:["Healthcare freedom","Parental rights","Rural health"],      bio:"Northern Michigan conservative. Focused on healthcare freedom and local governance. Strong GOP vote." },
  { id:"s37", chamber:"Senate", district:37, name:"John Damoose",       party:"R", region:"Harbor Springs / Petoskey",committees:["Appropriations","Economic & Community Dev.","Education (Minority Vice Chair)","Energy & Environment","Housing & Human Services (Minority Vice Chair)"],        ideology:7, keyIssues:["Tourism","Natural resources","Northern MI economy"],         bio:"Northern Michigan Republican focused on tourism and the region's economy. Moderate on some economic issues." },
  { id:"s38", chamber:"Senate", district:38, name:"Ed McBroom",         party:"R", region:"Upper Peninsula",          committees:["Elections & Ethics","Oversight (Minority Vice Chair)","Transportation & Infrastructure"],                  ideology:8, keyIssues:["Mining","UP economy","Natural resources"],                   bio:"UP Republican deeply focused on mining, forestry, and rural UP issues. Reliable conservative on most votes." },
];

const REPS_RAW = [
  [1,"Tyrone Carter","D","Wayne","4th"],
  [2,"Tullio Liberati","D","Wayne","3rd"],
  [3,"Alabas Farhat","D","Wayne","2nd"],
  [4,"Karen Whitsett","D","Wayne","4th"],
  [5,"Regina Weiss","D","Oakland/Wayne","3rd"],
  [6,"Natalie Price","D","Oakland/Wayne","2nd"],
  [7,"Tonya Myers Phillips","D","Oakland/Wayne","1st"],
  [8,"Helena Scott","D","Oakland/Wayne","3rd"],
  [9,"Joe Tate","D","Wayne","4th"],
  [10,"Veronica Paiz","D","Macomb/Wayne","2nd"],
  [11,"Donavan McKinney","D","Macomb/Wayne","2nd"],
  [12,"Kimberly Edwards","D","Macomb/Wayne","3rd"],
  [13,"Mai Xiong","D","Macomb/Wayne","2nd"],
  [14,"Mike McFall","D","Macomb/Wayne","2nd"],
  [15,"Erin Byrnes","D","Wayne","2nd"],
  [16,"Stephanie Young","D","Wayne","3rd"],
  [17,"Laurie Pohutsky","D","Wayne","4th"],
  [18,"Jason Hoskins","D","Oakland","2nd"],
  [19,"Samantha Steckloff","D","Oakland","3rd"],
  [20,"Noah Arbit","D","Oakland","2nd"],
  [21,"Kelly Breen","D","Oakland","3rd"],
  [22,"Matt Koleszar","D","Wayne","4th"],
  [23,"Jason Morgan","D","Oakland/Washtenaw/Wayne","2nd"],
  [24,"Ranjeev Puri","D","Wayne","3rd"],
  [25,"Peter Herzberg","D","Wayne","2nd"],
  [26,"Dylan Wegela","D","Wayne","2nd"],
  [27,"Rylee Linting","R","Wayne","1st"],
  [28,"Jamie Thompson","R","Monroe/Wayne","2nd"],
  [29,"James DeSana","R","Monroe/Wayne","2nd"],
  [30,"William Bruck","R","Lenawee/Monroe","2nd"],
  [31,"Reggie Miller","D","Lenawee/Monroe/Washtenaw/Wayne","2nd"],
  [32,"Jimmie Wilson Jr.","D","Washtenaw","2nd"],
  [33,"Morgan Foreman","D","Washtenaw","1st"],
  [34,"Nancy Jenkins-Arno","R","Lenawee","4th"],
  [35,"Jennifer Wortz","R","Branch/Hillsdale/Lenawee","1st"],
  [36,"Steve Carra","R","Cass/St. Joseph","3rd"],
  [37,"Brad Paquette","R","Berrien/Cass","4th"],
  [38,"Joey Andrews","D","Allegan/Berrien/Van Buren","2nd"],
  [39,"Pauline Wendzel","R","Allegan/Berrien/Van Buren","4th"],
  [40,"Matthew Longjohn","D","Kalamazoo","1st"],
  [41,"Julie Rogers","D","Kalamazoo","3rd"],
  [42,"Matt Hall","R","Allegan/Kalamazoo","4th"],
  [43,"Rachelle Smit","R","Allegan/Barry/Eaton/Ottawa","2nd"],
  [44,"Steve Frisbie","R","Calhoun","1st"],
  [45,"Sarah Lightner","R","Calhoun/Kalamazoo/Jackson","4th"],
  [46,"Kathy Schmaltz","R","Jackson/Washtenaw","2nd"],
  [47,"Carrie Rheingans","D","Jackson/Washtenaw","2nd"],
  [48,"Jennifer Conlin","D","Jackson/Livingston/Washtenaw","2nd"],
  [49,"Ann Bollin","R","Livingston/Oakland","4th"],
  [50,"Jason Woolford","R","Livingston","1st"],
  [51,"Matt Maddock","R","Oakland","4th"],
  [52,"Mike Harris","R","Oakland","3rd"],
  [53,"Brenda Carter","D","Oakland","4th"],
  [54,"Donni Steele","R","Oakland","2nd"],
  [55,"Mark Tisdel","R","Oakland","3rd"],
  [56,"Sharon MacDonell","D","Oakland","2nd"],
  [57,"Thomas Kuhn","R","Macomb/Oakland","2nd"],
  [58,"Ron Robinson","R","Macomb","1st"],
  [59,"Doug Wozniak","R","Macomb","4th"],
  [60,"Joseph Aragona","R","Macomb","2nd"],
  [61,"Denise Mentzer","D","Macomb","2nd"],
  [62,"Alicia St. Germaine","R","Macomb","2nd"],
  [63,"Jay DeBoyer","R","Macomb/St. Clair","2nd"],
  [64,"Joseph Pavlov","R","Sanilac/St. Clair","1st"],
  [65,"Jaime Greene","R","Lapeer/Macomb/St. Clair","2nd"],
  [66,"Josh Schriver","R","Macomb/Oakland","2nd"],
  [67,"Phil Green","R","Genesee/Lapeer/Tuscola","4th"],
  [68,"David Martin","R","Genesee/Oakland","3rd"],
  [69,"Jasper Martus","D","Genesee","2nd"],
  [70,"Cynthia Neeley","D","Genesee","4th"],
  [71,"Brian BeGole","R","Genesee/Saginaw/Shiawassee","2nd"],
  [72,"Mike Mueller","R","Genesee/Livingston/Oakland","4th"],
  [73,"Julie Brixie","D","Ingham","4th"],
  [74,"Kara Hope","D","Ingham","4th"],
  [75,"Penelope Tsernoglou","D","Clinton/Ingham/Shiawassee","2nd"],
  [76,"Angela Witwer","D","Eaton","4th"],
  [77,"Emily Dievendorf","D","Clinton/Eaton/Ingham","2nd"],
  [78,"Gina Johnsen","R","Barry/Eaton/Ionia/Kent","2nd"],
  [79,"Angela Rigas","R","Allegan/Barry/Kent","2nd"],
  [80,"Phil Skaggs","D","Kent","2nd"],
  [81,"Stephen Wooden","D","Kent","1st"],
  [82,"Kristian Grant","D","Kent","2nd"],
  [83,"John Fitzgerald","D","Kent","2nd"],
  [84,"Carol Glanville","D","Kent","3rd"],
  [85,"Bradley Slagh","R","Ottawa","4th"],
  [86,"Nancy De Boer","R","Allegan/Ottawa","2nd"],
  [87,"Will Snyder","D","Muskegon","2nd"],
  [88,"Greg VanWoerkom","R","Muskegon/Ottawa","4th"],
  [89,"Luke Meerman","R","Kent/Muskegon/Ottawa","4th"],
  [90,"Bryan Posthumus","R","Kent","3rd"],
  [91,"Pat Outman","R","Ionia/Kent/Montcalm","3rd"],
  [92,"Jerry Neyer","R","Gratiot/Isabella","2nd"],
  [93,"Tim Kelly","R","Clinton/Gratiot/Ionia/Montcalm/Saginaw","4th"],
  [94,"Amos O'Neal","D","Saginaw","3rd"],
  [95,"Bill G. Schuette","R","Gladwin/Midland","2nd"],
  [96,"Timothy Beson","R","Bay","3rd"],
  [97,"Matthew Bierlein","R","Bay/Genesee/Saginaw/Tuscola","2nd"],
  [98,"Gregory Alexander","R","Huron/Lapeer/Sanilac/Tuscola","2nd"],
  [99,"Mike Hoadley","R","Arenac/Bay/Clare/Gladwin/Iosco/Ogemaw","2nd"],
  [100,"Tom Kunse","R","Clare/Lake/Mecosta/Osceola","2nd"],
  [101,"Joseph Fox","R","Lake/Mason/Newaygo/Oceana/Wexford","2nd"],
  [102,"Curt VanderWall","R","Manistee/Mason/Muskegon/Oceana","4th"],
  [103,"Betsy Coffia","D","Benzie/Grand Traverse/Leelanau","2nd"],
  [104,"John Roth","R","Antrim/Benzie/Grand Traverse/Kalkaska/Manistee/Wexford","3rd"],
  [105,"Ken Borton","R","Antrim/Crawford/Kalkaska/Missaukee/Oscoda/Otsego/Roscommon","3rd"],
  [106,"Cam Cavitt","R","Alcona/Alpena/Cheboygan/Montmorency/Oscoda/Presque Isle","2nd"],
  [107,"Parker Fairbairn","R","Charlevoix/Chippewa/Emmet/Mackinac","1st"],
  [108,"David Prestin","R","Chippewa/Delta/Luce/Mackinac/Menominee/Schoolcraft","2nd"],
  [109,"Karl Bohnak","R","Alger/Baraga/Dickinson/Marquette","1st"],
  [110,"Gregory Markkanen","R","Dickinson/Gogebic/Houghton/Iron/Keweenaw/Ontonagon","4th"],
];

// Real verified committee assignments from house.mi.gov 2025-2026
// Source: Official House Standing Committees PDF (1/31/2025) + individual committee pages
// Chairs listed first with (Chair) notation per user requirement
const HOUSE_COMMITTEE_MAP = {
  1: ["Finance","Judiciary (Minority Vice Chair)","Regulatory Reform (Minority Vice Chair)"],
  2: ["Energy"],
  3: ["Appropriations (Minority Vice Chair)"],
  4: ["Health Policy (Minority Vice Chair)","Insurance","Regulatory Reform"],
  5: ["Education & Workforce","Natural Resources & Tourism"],
  6: ["Appropriations"],
  7: ["Energy","Natural Resources & Tourism"],
  8: ["Communications & Technology (Minority Vice Chair)","Judiciary","Natural Resources & Tourism"],
  9: ["Economic Competitiveness","Energy (Minority Vice Chair)","Finance"],
  10: ["Agriculture (Minority Vice Chair)","Finance"],
  11: ["Appropriations"],
  12: ["Appropriations"],
  13: ["Elections Integrity","Families & Veterans"],
  14: ["Government Operations","Natural Resources & Tourism (Minority Vice Chair)"],
  15: ["Education & Workforce","Families & Veterans"],
  16: ["Families & Veterans (Minority Vice Chair)","Finance"],
  17: ["Oversight"],
  18: ["Finance (Minority Vice Chair)","Health Policy"],
  19: ["Appropriations"],
  20: ["Communications & Technology","Natural Resources & Tourism"],
  21: ["Finance","Judiciary"],
  22: ["Education & Workforce","Elections Integrity","Transportation & Infrastructure"],
  23: ["Appropriations","Appropriations — Military & Veterans Affairs (Minority Vice Chair)","Appropriations — State & Local Transportation (Minority Vice Chair)"],
  24: ["House Minority Leader"],
  25: ["Energy","Rules","Transportation & Infrastructure"],
  26: ["Oversight"],
  27: ["Communications & Technology","Education & Workforce (Vice Chair)","Energy"],
  28: ["Energy","Families & Veterans","Health Policy (Vice Chair)"],
  29: ["Appropriations"],
  30: ["Oversight","Transportation & Infrastructure"],
  31: ["Oversight (Minority Vice Chair)","Transportation & Infrastructure"],
  32: ["Education & Workforce (Minority Vice Chair)"],
  33: ["Natural Resources & Tourism"],
  34: ["Appropriations","Appropriations — Labor & Economic Opportunity (Chair)","Appropriations — Joint Capital Outlay (Chair)"],
  35: ["Agriculture (Vice Chair)","Natural Resources & Tourism","Transportation & Infrastructure"],
  36: ["Oversight"],
  37: ["Education & Workforce","Oversight"],
  38: ["Communications & Technology","Energy"],
  39: ["Energy (Chair)","Communications & Technology","Regulatory Reform","Rules"],
  40: ["Appropriations"],
  41: ["Appropriations"],
  42: ["House Speaker"],
  43: ["Elections Integrity (Chair)"],
  44: ["Finance (Vice Chair)","Energy","Health Policy","Transportation & Infrastructure"],
  45: ["Judiciary (Chair)","Agriculture","Finance","Insurance"],
  46: ["Families & Veterans (Chair)","Communications & Technology","Energy","Health Policy"],
  47: ["Agriculture","Families & Veterans"],
  48: ["Oversight"],
  49: ["Appropriations (Chair)"],
  50: ["Families & Veterans","Oversight"],
  51: ["Appropriations (Vice Chair)"],
  52: ["Insurance (Chair)","Economic Competitiveness","Finance","Government Operations (Vice Chair)","Judiciary"],
  53: ["Health Policy","Insurance (Minority Vice Chair)"],
  54: ["Appropriations","Appropriations — State & Local Transportation (Chair)"],
  55: ["Finance (Chair)","Health Policy","Insurance (Vice Chair)","Regulatory Reform"],
  56: ["Oversight"],
  57: ["Appropriations","Appropriations — General Government (Chair)"],
  58: ["Appropriations","Appropriations — Military & Veterans Affairs (Chair)"],
  59: ["Families & Veterans (Vice Chair)","JCAR (Chair)","Judiciary","Regulatory Reform"],
  60: ["Regulatory Reform (Chair)","Economic Competitiveness","Finance","Insurance","Rules"],
  61: ["Oversight"],
  62: ["Economic Competitiveness","Education & Workforce","Natural Resources & Tourism (Vice Chair)"],
  63: ["Oversight (Chair)","Economic Competitiveness","Judiciary","Natural Resources & Tourism"],
  64: ["Agriculture","Education & Workforce","Elections Integrity","Families & Veterans"],
  65: ["Communications & Technology (Chair)","Appropriations — Public Health (Chair)","Oversight"],
  66: ["Communications & Technology"],
  67: ["Appropriations"],
  68: ["Natural Resources & Tourism (Chair)","Energy (Vice Chair)","Finance"],
  69: ["Appropriations"],
  70: ["Finance","Health Policy"],
  71: ["Government Operations (Chair)","Economic Competitiveness","Judiciary (Vice Chair)"],
  72: ["Appropriations","Appropriations — Michigan State Police (Chair)"],
  73: ["Economic Competitiveness","Energy"],
  74: ["Judiciary","Transportation & Infrastructure (Minority Vice Chair)"],
  75: ["Oversight"],
  76: ["Health Policy","Regulatory Reform","Rules"],
  77: ["Agriculture","Regulatory Reform"],
  78: ["Families & Veterans","Judiciary","Natural Resources & Tourism"],
  79: ["Oversight","Regulatory Reform"],
  80: ["Agriculture","Communications & Technology"],
  81: ["Elections Integrity (Minority Vice Chair)","Natural Resources & Tourism"],
  82: ["Economic Competitiveness (Minority Vice Chair)","Regulatory Reform","Transportation & Infrastructure"],
  83: ["Finance","Government Operations (Minority Vice Chair)","Insurance"],
  84: ["Appropriations"],
  85: ["Appropriations","Appropriations — Corrections & Judiciary (Chair)"],
  86: ["Education & Workforce (Chair)","Energy","Health Policy","Rules"],
  87: ["Appropriations"],
  88: ["Appropriations","Appropriations — Medicaid & Behavioral Health (Chair)"],
  89: ["Health Policy","Oversight (Vice Chair)"],
  90: ["House Majority Leader","Finance","Insurance","Rules"],
  91: ["Transportation & Infrastructure (Chair)","Economic Competitiveness","Elections Integrity","Natural Resources & Tourism"],
  92: ["Agriculture (Chair)","Insurance","Regulatory Reform","Transportation & Infrastructure"],
  93: ["Appropriations","Appropriations — School Aid & Dept. of Education (Chair)"],
  94: ["Appropriations"],
  95: ["Rules (Chair)","Finance","Insurance","Judiciary"],
  96: ["Appropriations","Appropriations — LARA/IFS (Chair)"],
  97: ["Oversight (Vice Chair)","Health Policy"],
  98: ["Agriculture","Elections Integrity","Finance","Transportation & Infrastructure"],
  99: ["Economic Competitiveness (Chair)","Elections Integrity","Natural Resources & Tourism","Regulatory Reform"],
  100: ["Communications & Technology (Vice Chair)","Agriculture","Education & Workforce","Transportation & Infrastructure"],
  101: ["Elections Integrity (Vice Chair)","Agriculture","Education & Workforce","Families & Veterans"],
  102: ["Health Policy (Chair)","Finance","Government Operations","Natural Resources & Tourism"],
  103: ["Economic Competitiveness","Energy"],
  104: ["Appropriations","Appropriations — Human Services (Chair)"],
  105: ["Appropriations","Appropriations — Agriculture & DNR (Chair)"],
  106: ["Appropriations","Appropriations — EGLE (Chair)"],
  107: ["Communications & Technology","Natural Resources & Tourism","Regulatory Reform"],
  108: ["Energy (Vice Chair)","Health Policy","Natural Resources & Tourism","Transportation & Infrastructure"],
  109: ["Economic Competitiveness (Vice Chair)","Health Policy","Natural Resources & Tourism","Transportation & Infrastructure"],
  110: ["Appropriations","Appropriations — Higher Education & Community Colleges (Chair)"],
};

const REP_ISSUES = {
  D: [["Education funding","Healthcare access","Labor rights"],["Environment","Housing","Civil rights"],["Workforce development","Infrastructure","Equity"],["Criminal justice reform","Climate","Consumer protection"]],
  R: [["Fiscal responsibility","Lower taxes","Deregulation"],["Law enforcement","School choice","Property rights"],["Agriculture","Small business","Energy"],["Election integrity","Second Amendment","Anti-mandate"]],
};

const REP_IDEOLOGY = {
  D: {1:3,2:4,3:3,4:5,5:3,6:3,7:3,8:3,9:4,10:4,11:4,12:4,13:4,14:4,15:4,16:3,17:3,18:4,19:4,20:3,21:4,22:4,23:4,24:3,25:4,26:4,31:5,32:4,33:4,38:5,40:4,41:4,47:4,48:5,53:4,56:4,61:5,69:4,70:4,73:3,74:3,75:4,76:4,77:3,80:4,81:4,82:4,83:4,84:4,87:4,94:4,103:4},
  R: {27:7,28:7,29:8,30:7,34:8,35:8,36:9,37:8,39:8,42:7,43:7,44:7,45:8,46:7,49:8,50:8,51:9,52:7,54:7,55:7,57:7,58:8,59:8,60:7,62:7,63:8,64:8,65:7,66:9,67:8,68:7,71:7,72:7,78:7,79:8,85:8,86:7,88:8,89:8,90:8,91:8,92:8,93:8,95:8,96:7,97:7,98:8,99:7,100:8,101:8,102:8,104:7,105:8,106:8,107:7,108:8,109:8,110:9},
};

const REPRESENTATIVES = REPS_RAW.map(([district, name, party, region, term], i) => {
  const committees = HOUSE_COMMITTEE_MAP[district] || (party === "D" ? ["Appropriations"] : ["Regulatory Reform"]);
  const ideology = REP_IDEOLOGY[party][district] || (party === "D" ? 4 : 7);
  return {
    id: `h${district}`,
    chamber: "House",
    district,
    name,
    party,
    region,
    term,
    committees,
    ideology,
    keyIssues: REP_ISSUES[party][i % 4],
    bio: `${party === "D" ? "Democrat" : "Republican"} representing District ${district} (${region}). ${term} term. Serves on ${committees.slice(0,2).join(" and ")} committee${committees.length > 1 ? "s" : ""}.`,
  };
});

const ALL_LEGISLATORS = [...SENATORS.filter(s => s.name !== "[Vacant]"), ...REPRESENTATIVES];

// --- STYLES ---


function displayStatus(s) {
  const MAP = {
    "Introduced":"Introduced","Engrossed":"In Progress","Enrolled":"PA Signed",
    "Chaptered":"PA Signed","Passed":"Passed","Failed":"Failed","Vetoed":"Vetoed",
    "Report Pass":"In Committee","Report Fail":"In Committee","Refer":"In Committee",
    "Override":"Passed","Draft":"Draft",
  };
  return MAP[s] || s || "Introduced";
}
// ─── QUERY RATE LIMITING ──────────────────────────────────────────────────────
const DAILY_LIMIT = 25;

async function getQueryUsage(userId) {
  const today = new Date().toISOString().split("T")[0];
  const { data } = await supabase
    .from("query_usage")
    .select("count")
    .eq("user_id", userId)
    .eq("query_date", today)
    .single();
  return data?.count || 0;
}

async function incrementQueryUsage(userId) {
  const today = new Date().toISOString().split("T")[0];
  const { data } = await supabase
    .from("query_usage")
    .select("id, count")
    .eq("user_id", userId)
    .eq("query_date", today)
    .single();
  if (data) {
    await supabase.from("query_usage").update({ count: data.count + 1, updated_at: new Date().toISOString() }).eq("id", data.id);
    return data.count + 1;
  } else {
    await supabase.from("query_usage").insert({ user_id: userId, query_date: today, count: 1 });
    return 1;
  }
}

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800&family=IBM+Plex+Sans:wght@300;400;500&family=IBM+Plex+Mono:wght@400;500&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
html,body{height:100%;overflow:hidden;}
/* Theme variables defined globally in public/theme.css */
body{background:var(--bg);color:var(--text);font-family:var(--font-body);-webkit-font-smoothing:antialiased;}
.vote-history-btn{background:var(--gold);border:none;border-radius:8px;padding:0.6rem 1.25rem;color:#09090e;font-family:var(--font-mono);font-size:0.75rem;font-weight:700;cursor:pointer;letter-spacing:0.08em;transition:all 0.18s;white-space:nowrap;flex-shrink:0;box-shadow:0 2px 8px rgba(201,168,76,0.3);}
.vote-history-btn:hover{background:#d4b05a;transform:translateY(-1px);box-shadow:0 4px 12px rgba(201,168,76,0.4);}
.vh-pane{flex:1;display:flex;flex-direction:column;overflow:hidden;position:relative;}
.vh-header{padding:0.85rem 1.5rem;border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;flex-shrink:0;background:var(--surface);}
.vh-title{font-family:var(--font-display);font-size:1rem;font-weight:700;color:var(--text);}
.vh-subtitle{font-family:var(--font-mono);font-size:0.7rem;color:var(--muted);}
.vh-close{background:transparent;border:1px solid var(--border);border-radius:6px;padding:0.3rem 0.75rem;color:var(--muted);font-family:var(--font-mono);font-size:0.7rem;cursor:pointer;letter-spacing:0.06em;transition:all 0.18s;}
.vh-close:hover{border-color:var(--gold-dim);color:var(--gold);}
.vh-filter-btn{background:var(--surface2);border:1px solid var(--border);border-radius:100px;padding:0.22rem 0.85rem;font-size:0.68rem;font-family:var(--font-mono);color:var(--muted);cursor:pointer;transition:all 0.15s;letter-spacing:0.05em;font-weight:500;}
.vh-filter-btn:hover{background:var(--charcoal);border-color:var(--gold-dim);color:var(--text);}
.vh-filter-btn.active{background:var(--gold-glow);border-color:var(--gold-dim);color:var(--gold);font-weight:600;}
.vh-stats{display:flex;gap:1rem;padding:0.85rem 1.5rem;border-bottom:1px solid var(--border);flex-shrink:0;background:var(--surface2);}
.vh-stat{text-align:center;}
.vh-stat-val{font-family:var(--font-display);font-size:1.1rem;font-weight:700;color:var(--text);}
.vh-stat-val.yea{color:#3ba360;}
.vh-stat-val.nay{color:var(--rep);}
.vh-stat-label{font-family:var(--font-mono);font-size:0.65rem;color:var(--muted);letter-spacing:0.08em;text-transform:uppercase;}
.vh-list{flex:1;overflow-y:auto;scrollbar-width:thin;scrollbar-color:var(--border) transparent;}
.vh-item{display:flex;align-items:center;gap:1rem;padding:0.85rem 1.5rem;border-bottom:1px solid var(--border);transition:background 0.15s;}
.vh-item:hover{background:var(--surface2);}
.vh-vote-badge{width:48px;flex-shrink:0;text-align:center;font-family:var(--font-mono);font-size:0.68rem;font-weight:600;padding:0.22rem 0.3rem;border-radius:5px;letter-spacing:0.04em;}
.vh-vote-badge.yea{background:rgba(59,163,96,0.12);color:#3ba360;border:1px solid rgba(59,163,96,0.25);}
.vh-vote-badge.nay{background:rgba(212,59,59,0.12);color:var(--rep);border:1px solid rgba(212,59,59,0.2);}
.vh-vote-badge.absent{background:var(--surface2);color:var(--muted);border:1px solid var(--border);}
.vh-vote-badge.nv{background:var(--surface2);color:var(--muted);border:1px solid var(--border);}
.vh-bill-number{font-family:var(--font-mono);font-size:0.72rem;color:var(--gold);flex-shrink:0;width:68px;}
.vh-bill-title{font-size:0.83rem;color:var(--text);flex:1;line-height:1.4;}
.vh-bill-meta{font-family:var(--font-mono);font-size:0.68rem;color:var(--muted);flex-shrink:0;text-align:right;line-height:1.6;}
.vh-outcome.passed{color:#3ba360;}
.vh-outcome.failed{color:var(--rep);}
.vh-loading{flex:1;display:flex;align-items:center;justify-content:center;gap:0.75rem;font-family:var(--font-mono);font-size:0.75rem;color:var(--muted);}
.vh-loading-ring{width:28px;height:28px;border:2px solid var(--border);border-top-color:var(--gold);border-radius:50%;animation:spin 1s linear infinite;}
.vh-error{padding:1.5rem;font-family:var(--font-mono);font-size:0.75rem;color:#d43b3b;line-height:1.6;}
.vh-source{font-family:var(--font-mono);font-size:0.6rem;color:var(--muted);padding:0.4rem 1.5rem;opacity:0.5;flex-shrink:0;}
.vh-filters{padding:0.65rem 1.5rem 0.55rem;border-bottom:none;display:flex;align-items:center;gap:0.4rem;background:var(--surface);flex-shrink:0;}
.vh-cat-filters{padding:0.55rem 1.5rem 0.7rem;border-bottom:1px solid var(--border);display:grid;grid-template-columns:repeat(4,1fr);gap:5px;background:var(--surface);flex-shrink:0;}
.vh-filter-row-sep{height:1px;background:var(--border);margin:0 1.5rem;flex-shrink:0;}
.vh-cat-btn{border-radius:100px;padding:0.22rem 0.5rem;font-size:0.68rem;font-family:var(--font-mono);cursor:pointer;transition:all 0.15s;letter-spacing:0.04em;display:flex;align-items:center;justify-content:center;gap:0.3rem;font-weight:500;width:100%;background:var(--surface2);border:1px solid var(--border);color:var(--muted);}
.vh-cat-btn:hover{background:var(--charcoal);border-color:var(--gold-dim);color:var(--text);}
.vh-cat-btn.active{background:var(--gold-glow);border-color:var(--gold-dim);color:var(--gold);font-weight:600;}
.vh-cat-count{border-radius:100px;padding:0 0.35rem;font-size:0.6rem;min-width:1.1rem;text-align:center;opacity:0.5;}
.vh-cat-btn.active .vh-cat-count{opacity:0.75;}
.vh-cat-chip{display:inline-flex;align-items:center;font-family:var(--font-mono);font-size:0.6rem;padding:0.08rem 0.45rem;border-radius:100px;letter-spacing:0.04em;flex-shrink:0;white-space:nowrap;margin-top:0.25rem;font-weight:500;}
[data-theme="light"] .vh-filters,[data-theme="light"] .vh-cat-filters{background:var(--surface);border-color:var(--border);}
[data-theme="light"] .vh-filter-row-sep{background:var(--border);}
[data-theme="light"] .vh-filter-btn{background:#d0d8ed;border-color:#a8b8d8;color:#3a4a6b;}
[data-theme="light"] .vh-cat-btn{background:#d0d8ed;border-color:#a8b8d8;color:#3a4a6b;}
[data-theme="light"] .vh-cat-btn.active{background:var(--gold-glow);border-color:var(--gold-dim);color:var(--gold);}
[data-theme="light"] .vh-filter-btn.active{background:var(--gold-glow);border-color:var(--gold-dim);color:var(--gold);}
[data-theme="light"] .vh-filter-btn:hover,[data-theme="light"] .vh-cat-btn:hover{background:var(--surface2);border-color:rgba(26,39,68,0.3);color:var(--text);}
[data-theme="light"] .vh-filter-btn.active,[data-theme="light"] .vh-cat-btn.active{background:var(--gold-glow);border-color:var(--gold-dim);color:var(--gold);}

/* LAYOUT */
.app{display:flex;flex-direction:column;height:100vh;overflow:hidden;background:var(--bg);}.app-body{display:flex;flex:1;overflow:hidden;}
.sidebar{width:320px;flex-shrink:0;background:var(--surface);border-right:1px solid var(--border);display:flex;flex-direction:column;overflow:hidden;position:relative;}
.sidebar-inner{width:320px;display:flex;flex-direction:column;flex:1;overflow:hidden;}
.sidebar-collapsed{display:none;}
.collapsed-search{width:36px;height:36px;border-radius:10px;background:var(--gold-glow);border:1px solid var(--gold-dim);display:flex;align-items:center;justify-content:center;cursor:pointer;transition:background 0.2s,transform 0.15s;margin-bottom:0.5rem;}
.collapsed-search:hover{background:rgba(201,168,76,0.25);transform:scale(1.05);}
.collapsed-search svg{width:16px;height:16px;stroke:var(--gold);stroke-width:2;fill:none;stroke-linecap:round;stroke-linejoin:round;}
.main{flex:1;display:flex;flex-direction:column;overflow:hidden;}

/* SIDEBAR HEADER */
.sidebar-header{padding:1.1rem 1.25rem;border-bottom:1px solid var(--border);flex-shrink:0;}
.logo{font-family:var(--font-display);font-size:1.15rem;font-weight:800;color:var(--text);line-height:1;}
.logo em{font-style:normal;color:var(--gold);}
.logo sup{font-family:var(--font-body);font-size:0.5rem;color:var(--muted);vertical-align:super;}
.logo-sub{font-family:var(--font-mono);font-size:0.62rem;color:var(--muted);letter-spacing:0.1em;text-transform:uppercase;margin-top:0.2rem;}

/* SEARCH & FILTERS */
.search-area{padding:0.85rem 1.25rem;border-bottom:1px solid var(--border);flex-shrink:0;}
.search-input{width:100%;background:var(--surface2);border:1px solid var(--border);border-radius:6px;padding:0.55rem 0.85rem;color:var(--text);font-family:var(--font-body);font-size:0.83rem;outline:none;transition:border-color 0.2s;}
.search-input:focus{border-color:var(--gold-dim);}
.search-input::placeholder{color:var(--muted);}
.filters{display:flex;gap:0.4rem;margin-top:0.6rem;flex-wrap:wrap;}
.filter-btn{background:var(--surface2);border:1px solid var(--border);border-radius:100px;padding:0.25rem 0.75rem;font-size:0.7rem;font-family:var(--font-mono);color:var(--muted);cursor:pointer;transition:all 0.15s;letter-spacing:0.05em;}
.filter-btn:hover{border-color:var(--gold-dim);color:var(--text);}
.filter-btn.active{background:var(--gold-glow);border-color:var(--gold-dim);color:var(--gold);}
.filter-btn.dem-active{background:var(--dem-bg);border-color:var(--dem);color:var(--dem);}
.filter-btn.rep-active{background:var(--rep-bg);border-color:var(--rep);color:var(--rep);}

/* LEGISLATOR LIST */
.list-meta{padding:0.5rem 1.25rem;font-family:var(--font-mono);font-size:0.65rem;color:var(--muted);letter-spacing:0.08em;border-bottom:1px solid var(--border);flex-shrink:0;}
.leg-list{flex:1;overflow-y:auto;scrollbar-width:thin;scrollbar-color:var(--border) transparent;}
.leg-item{display:flex;align-items:center;gap:0.75rem;padding:0.75rem 1.25rem;cursor:pointer;border-bottom:1px solid var(--border);transition:background 0.15s;position:relative;}
.leg-item:hover{background:var(--surface2);}
.leg-item.selected{background:var(--charcoal);}
.leg-item.selected::before{content:'';position:absolute;left:0;top:0;bottom:0;width:2px;background:var(--gold);}
.leg-avatar{width:36px;height:36px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-family:var(--font-display);font-weight:800;font-size:0.85rem;flex-shrink:0;}
.leg-avatar.D{background:var(--dem-bg);color:var(--dem);}
.leg-avatar.R{background:var(--rep-bg);color:var(--rep);}
.leg-name{font-size:0.82rem;font-weight:500;color:var(--text);line-height:1.2;}
.leg-meta{font-size:0.68rem;color:var(--muted);font-family:var(--font-mono);}
.leg-badge{margin-left:auto;font-size:0.6rem;font-family:var(--font-mono);padding:0.15rem 0.4rem;border-radius:4px;flex-shrink:0;}
.leg-badge.D{background:var(--dem-bg);color:var(--dem);border:1px solid rgba(59,111,212,0.2);}
.leg-badge.R{background:var(--rep-bg);color:var(--rep);border:1px solid rgba(212,59,59,0.2);}

/* MAIN AREA */
.main-topbar{padding:0.85rem 1.5rem;border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;flex-shrink:0;background:var(--surface);}
.topbar-left{display:flex;align-items:center;gap:0.75rem;}
.topbar-avatar{width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-family:var(--font-display);font-weight:800;font-size:0.78rem;}
.topbar-avatar.D{background:var(--dem-bg);color:var(--dem);}
.topbar-avatar.R{background:var(--rep-bg);color:var(--rep);}
.topbar-name{font-family:var(--font-display);font-size:1rem;font-weight:700;color:var(--text);}
.topbar-sub{font-family:var(--font-mono);font-size:0.65rem;color:var(--muted);}
.topbar-badges{display:flex;gap:0.4rem;align-items:center;}
.badge-chip{font-family:var(--font-mono);font-size:0.6rem;padding:0.2rem 0.5rem;border-radius:4px;border:1px solid var(--border);color:var(--muted);}
.badge-chip.D{background:var(--dem-bg);color:var(--dem);border-color:rgba(59,111,212,0.25);}
.badge-chip.R{background:var(--rep-bg);color:var(--rep);border-color:rgba(212,59,59,0.25);}

/* PROFILE PANE */
.profile-pane{display:flex;height:100%;overflow:hidden;}
.profile-sidebar{width:260px;flex-shrink:0;border-right:1px solid var(--border);overflow-y:auto;padding:1.25rem;background:var(--surface2);}
.profile-section{margin-bottom:1.5rem;}
.profile-section-label{font-family:var(--font-mono);font-size:0.62rem;color:var(--gold);letter-spacing:0.12em;text-transform:uppercase;margin-bottom:0.6rem;padding-bottom:0.3rem;border-bottom:1px solid var(--gold-dim);}
.profile-section p{font-size:0.82rem;color:var(--muted);line-height:1.65;font-weight:300;}
.issue-tag{display:inline-block;background:var(--charcoal);border:1px solid var(--border);border-radius:4px;padding:0.2rem 0.5rem;font-size:0.7rem;color:var(--muted);margin:0.2rem 0.2rem 0 0;}
.committee-tag{display:block;font-size:0.75rem;color:var(--text);padding:0.3rem 0;border-bottom:1px solid var(--border);font-family:var(--font-mono);}
.ideology-bar{height:6px;background:var(--surface);border-radius:100px;margin-top:0.4rem;overflow:hidden;}
.ideology-fill{height:100%;border-radius:100px;background:linear-gradient(90deg,var(--dem),var(--rep));}

/* CHAT PANE */
.chat-pane{flex:1;display:flex;flex-direction:column;overflow:hidden;min-height:0;}
.chat-notice{padding:0.6rem 1.25rem;background:rgba(201,168,76,0.06);border-bottom:1px solid var(--border);font-family:var(--font-mono);font-size:0.65rem;color:var(--muted);line-height:1.5;}
.chat-notice strong{color:var(--gold);}
.chat-messages{flex:1;overflow-y:auto;padding:1.25rem;display:flex;flex-direction:column;gap:1rem;scrollbar-width:thin;scrollbar-color:var(--border) transparent;}
.msg{display:flex;gap:0.75rem;max-width:85%;}
.msg.user{flex-direction:row-reverse;align-self:flex-end;}
.msg-bubble{background:var(--surface2);border:1px solid var(--border);border-radius:10px;padding:0.85rem 1rem;font-size:0.87rem;line-height:1.65;color:var(--text);}
.msg.user .msg-bubble{background:var(--charcoal);border-color:var(--gold-dim);}
.msg-avatar{width:30px;height:30px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:0.7rem;font-weight:700;flex-shrink:0;margin-top:2px;}
.msg-avatar.ai.D{background:var(--dem-bg);color:var(--dem);font-family:var(--font-display);}
.msg-avatar.ai.R{background:var(--rep-bg);color:var(--rep);font-family:var(--font-display);}
.msg-avatar.user{background:var(--charcoal);color:var(--gold);font-family:var(--font-mono);}
.msg-label{font-family:var(--font-mono);font-size:0.6rem;color:var(--muted);margin-bottom:0.3rem;}
.typing-dot{display:inline-block;width:6px;height:6px;border-radius:50%;background:var(--muted);margin:0 2px;animation:typing-bounce 1.2s infinite;}
.typing-dot:nth-child(2){animation-delay:0.2s;}
.typing-dot:nth-child(3){animation-delay:0.4s;}
@keyframes typing-bounce{0%,100%{transform:translateY(0)}50%{transform:translateY(-5px)}}

/* CHAT INPUT */
.chat-input-area{padding:1rem 1.25rem;border-top:1px solid var(--border);background:var(--surface);flex-shrink:0;}
.chat-input-row{display:flex;gap:0.75rem;align-items:center;}
.chat-input{flex:1;background:var(--surface2);border:1px solid var(--border);border-radius:8px;padding:0.75rem 1rem;color:var(--text);font-family:var(--font-body);font-size:0.87rem;outline:none;resize:none;min-height:44px;max-height:120px;transition:border-color 0.2s;line-height:1.5;}
.chat-input:focus{border-color:var(--gold-dim);}
.chat-input::placeholder{color:var(--muted);}
.send-btn{background:var(--gold);color:#09090e;border:none;border-radius:8px;padding:0.75rem 1.1rem;font-family:var(--font-body);font-size:0.82rem;font-weight:500;cursor:pointer;transition:background 0.2s,transform 0.15s;flex-shrink:0;}
.send-btn:hover{background:#d4b05a;transform:translateY(-1px);}
.send-btn:disabled{background:var(--surface2);color:var(--muted);cursor:not-allowed;transform:none;}
.quick-prompts{display:flex;gap:0.4rem;margin-bottom:0.75rem;flex-wrap:wrap;}
.qp-btn{background:var(--surface2);border:1px solid var(--border);border-radius:100px;padding:0.3rem 0.75rem;font-size:0.7rem;color:var(--muted);cursor:pointer;font-family:var(--font-mono);transition:all 0.15s;white-space:nowrap;}
.qp-btn:hover{border-color:var(--gold-dim);color:var(--text);}

/* EMPTY STATE */
.empty-state{flex:1;display:flex;align-items:center;justify-content:center;flex-direction:column;gap:1rem;color:var(--muted);text-align:center;padding:2rem;}
.empty-icon{font-size:2.5rem;opacity:0.3;}
.empty-title{font-family:var(--font-display);font-size:1.3rem;font-weight:700;color:var(--text);opacity:0.5;}
.empty-sub{font-size:0.85rem;line-height:1.65;max-width:340px;font-weight:300;}
.empty-grid{display:grid;grid-template-columns:1fr 1fr;gap:0.5rem;margin-top:0.5rem;width:100%;max-width:400px;}
.empty-card{background:var(--surface2);border:1px solid var(--border);border-radius:8px;padding:0.75rem;cursor:pointer;text-align:left;transition:border-color 0.2s;}
.empty-card:hover{border-color:var(--gold-dim);}
.empty-card-name{font-size:0.8rem;font-weight:500;color:var(--text);}
.empty-card-sub{font-size:0.68rem;color:var(--muted);font-family:var(--font-mono);margin-top:0.2rem;}

/* HOME BUTTON */
.home-btn{background:transparent;border:1px solid var(--border);border-radius:6px;padding:0.4rem 0.9rem;color:var(--muted);font-family:var(--font-mono);font-size:0.68rem;cursor:pointer;letter-spacing:0.06em;transition:all 0.2s;display:flex;align-items:center;gap:0.4rem;}
.home-btn:hover{border-color:var(--gold-dim);color:var(--gold);}

/* LEGISIM MASTHEAD */
.legisim-masthead{flex-shrink:0;background:var(--surface);border-bottom:2px solid rgba(201,168,76,0.22);padding:0 1.25rem;display:flex;align-items:center;justify-content:space-between;height:58px;position:relative;z-index:20;}
.legisim-masthead::before{content:'';position:absolute;top:0;left:0;right:0;height:2px;background:linear-gradient(90deg,transparent 0%,var(--gold) 30%,#e8c96a 50%,var(--gold) 70%,transparent 100%);}
.legisim-masthead::after{content:'';position:absolute;inset:0;background-image:linear-gradient(rgba(201,168,76,0.025) 1px,transparent 1px),linear-gradient(90deg,rgba(201,168,76,0.025) 1px,transparent 1px);background-size:44px 44px;pointer-events:none;}
.masthead-left{display:flex;align-items:center;gap:1rem;z-index:1;}
.masthead-right{display:flex;align-items:center;gap:0.6rem;z-index:1;}
.mast-back{background:transparent;border:2px solid var(--gold-dim);border-radius:8px;padding:0.45rem 1.1rem;color:var(--gold);font-family:var(--font-mono);font-size:0.72rem;font-weight:600;cursor:pointer;letter-spacing:0.07em;transition:all 0.18s;white-space:nowrap;}
.mast-back:hover{border-color:var(--gold);background:var(--gold-glow);}
.mast-btn-sm{background:transparent;border:1px solid var(--border);border-radius:8px;padding:0.4rem 1rem;color:var(--muted);font-family:var(--font-mono);font-size:0.7rem;cursor:pointer;letter-spacing:0.06em;transition:all 0.18s;white-space:nowrap;}
.mast-btn-sm:hover{border-color:var(--gold-dim);color:var(--gold);}
.mast-btn-sm.signout:hover{border-color:rgba(192,57,43,0.5);color:var(--red);}
.masthead-wordmark{display:flex;align-items:baseline;font-family:var(--font-display);font-size:1.35rem;font-weight:800;letter-spacing:-0.02em;color:var(--text);line-height:1;white-space:nowrap;}
.masthead-wordmark em{font-style:italic;color:var(--gold);}
.masthead-wordmark sup{font-family:var(--font-mono);font-size:0.42rem;font-weight:500;color:var(--muted);vertical-align:super;letter-spacing:0.08em;margin-left:1px;}
.masthead-divider{width:1px;height:20px;background:var(--border);flex-shrink:0;}
.masthead-tagline{display:none;}
.masthead-badge{display:inline-flex;align-items:center;gap:0.3rem;background:rgba(201,168,76,0.08);border:1px solid rgba(201,168,76,0.2);border-radius:100px;padding:0.18rem 0.6rem;font-family:var(--font-mono);font-size:0.54rem;color:var(--gold);letter-spacing:0.1em;text-transform:uppercase;white-space:nowrap;}
.masthead-badge-dot{width:5px;height:5px;border-radius:50%;background:var(--gold);animation:mbpulse 2.5s infinite;}
@keyframes mbpulse{0%,100%{opacity:0.4;transform:scale(0.85)}50%{opacity:1;transform:scale(1.1)}}
.masthead-nav{display:flex;align-items:center;gap:0.3rem;z-index:1;flex-shrink:1;overflow:hidden;}
.mast-btn{background:transparent;border:1px solid var(--border);border-radius:6px;padding:0.36rem 0.7rem;color:var(--muted);font-family:var(--font-mono);font-size:0.64rem;font-weight:500;cursor:pointer;letter-spacing:0.07em;transition:all 0.18s;white-space:nowrap;display:flex;align-items:center;gap:0.3rem;}
.mast-btn:hover{border-color:var(--gold-dim);color:var(--gold);background:rgba(201,168,76,0.05);}
.mast-btn.gold{border-color:var(--gold-dim);color:var(--gold);}
.mast-btn.gold:hover{background:rgba(201,168,76,0.1);}
.mast-btn.active{border-color:var(--gold);color:var(--gold);background:rgba(201,168,76,0.1);}
.mast-sep{width:1px;height:16px;background:var(--border);margin:0 0.1rem;}


/* SCROLLBAR */
::-webkit-scrollbar{width:4px;}
::-webkit-scrollbar-track{background:transparent;}
::-webkit-scrollbar-thumb{background:var(--border);border-radius:4px;}
@media(max-width:768px){
  .masthead-tagline{display:none;}
  .masthead-badge{display:none;}
  .masthead-nav{display:none !important;}
  .legisim-masthead{flex-shrink:0;background:var(--surface);border-bottom:2px solid rgba(201,168,76,0.22);padding:0 1.25rem;display:flex;align-items:center;justify-content:space-between;height:58px;position:relative;z-index:20;}
  .sidebar{position:fixed;left:0;top:58px;bottom:0;z-index:50;transform:translateX(-100%);transition:transform 0.25s cubic-bezier(0.4,0,0.2,1);width:85vw !important;max-width:320px;box-shadow:4px 0 24px rgba(0,0,0,0.4);}
  .sidebar.mobile-open{transform:translateX(0);}
  .mobile-sidebar-overlay{display:block;position:fixed;inset:0;top:58px;background:rgba(0,0,0,0.6);z-index:49;backdrop-filter:blur(2px);}
  .mobile-sidebar-toggle{display:flex;align-items:center;gap:0.4rem;background:var(--charcoal);border:1px solid var(--border);border-radius:8px;padding:0.4rem 0.85rem;font-family:var(--font-mono);font-size:0.65rem;color:var(--muted);cursor:pointer;margin:0.75rem 1rem 0;transition:all 0.15s;}
  .mobile-sidebar-toggle:hover{border-color:var(--gold-dim);color:var(--gold);}
  .app-body{flex-direction:column;}
}

@media(max-width:1200px){
  .mast-btn{padding:0.3rem 0.45rem;font-size:0.58rem;letter-spacing:0.03em;}
  .masthead-nav{gap:0.2rem;}
}
@media(max-width:900px){
  .mast-btn{padding:0.28rem 0.38rem;font-size:0.55rem;}
  .masthead-nav{gap:0.15rem;}
}
@media(max-width:768px){
  .masthead-nav{display:none !important;}
  .legisim-masthead{flex-shrink:0;background:var(--surface);border-bottom:2px solid rgba(201,168,76,0.22);padding:0 1.25rem;display:flex;align-items:center;justify-content:space-between;height:58px;position:relative;z-index:20;}
}

/* ── LIGHT MODE OVERRIDES ── */
[data-theme="light"] body{background:#eef1f7;color:#1a1e2e;}
[data-theme="light"] .page,[data-theme="light"] .app,[data-theme="light"] .bt-app,[data-theme="light"] .tl-app,[data-theme="light"] .map-app,[data-theme="light"] .cf-app{background:#eef1f7;}
[data-theme="light"] .legisim-masthead{background:#1a2744;border-bottom-color:rgba(255,255,255,0.1);}
[data-theme="light"] .legisim-masthead::before{background:linear-gradient(90deg,transparent,var(--gold),transparent);}
[data-theme="light"] .masthead-wordmark{color:#e6e4dc;}
[data-theme="light"] .masthead-wordmark em{color:#c9a84c;}
[data-theme="light"] .masthead-wordmark sup{color:rgba(230,228,220,0.5);}
[data-theme="light"] .mast-back{border-color:rgba(201,168,76,0.6);color:#c9a84c;background:transparent;}
[data-theme="light"] .mast-back:hover{background:rgba(201,168,76,0.12);border-color:#c9a84c;color:#c9a84c;}
[data-theme="light"] .mast-btn-sm{color:#e6e4dc;border-color:rgba(201,168,76,0.4);}
[data-theme="light"] .mast-btn-sm:hover{color:#ffffff;border-color:#c9a84c;background:rgba(201,168,76,0.1);}
[data-theme="light"] .mast-btn-sm.signout:hover{border-color:rgba(192,57,43,0.7);color:#ff6b6b;background:rgba(192,57,43,0.1);}
[data-theme="light"] .sidebar,[data-theme="light"] .bt-left,[data-theme="light"] .cal-sidebar,[data-theme="light"] .cf-sidebar,[data-theme="light"] .map-left{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .main,[data-theme="light"] .bt-detail,[data-theme="light"] .cf-main{background:#eef1f7;}
[data-theme="light"] .filter-btn.active{background:rgba(26,39,68,0.1);border-color:rgba(26,39,68,0.3);color:#1a2744;}
[data-theme="light"] .filter-btn.dem-active{background:var(--dem-bg);border-color:var(--dem);color:var(--dem);}
[data-theme="light"] .filter-btn.rep-active{background:var(--rep-bg);border-color:var(--rep);color:var(--rep);}
[data-theme="light"] .search-input,[data-theme="light"] .chat-input,[data-theme="light"] .bt-search-input,[data-theme="light"] .tl-search-input{background:#f8f9fc;border-color:rgba(26,39,68,0.12);color:#1a1e2e;}
[data-theme="light"] .leg-item.selected{background:#e8ecf4;}
[data-theme="light"] .leg-item.selected::before{background:#1a2744;}
[data-theme="light"] .leg-item:hover{background:#e8ecf4;}
[data-theme="light"] .chat-input-area{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .msg-bubble{background:#f0f2f8;border-color:rgba(26,39,68,0.1);}
[data-theme="light"] .msg.user .msg-bubble{background:#e8ecf4;border-color:rgba(26,39,68,0.2);}
[data-theme="light"] .send-btn{background:#1a2744;color:#f8f9fc;}
[data-theme="light"] .main-topbar,[data-theme="light"] .news-topbar,[data-theme="light"] .chamber-bar,[data-theme="light"] .toggle-bar{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .vh-header,[data-theme="light"] .vh-stats{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .vh-bill-number,[data-theme="light"] .bt-bill-number,[data-theme="light"] .bt-detail-number,[data-theme="light"] .tl-bill-number,[data-theme="light"] .district-num{color:#1a2744;}
[data-theme="light"] .profile-section-label,[data-theme="light"] .section-label,[data-theme="light"] .form-label,[data-theme="light"] .panel-title,[data-theme="light"] .output-label,[data-theme="light"] .floor-title,[data-theme="light"] .detail-title,[data-theme="light"] .search-section-label{color:#1a2744;}
[data-theme="light"] .input-panel{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .output-panel,[data-theme="light"] .output-body{background:#eef1f7;}
[data-theme="light"] .tl-add-btn,[data-theme="light"] .tl-refresh-btn,[data-theme="light"] .tl-view-btn{color:#1a2744;border-color:rgba(26,39,68,0.2);}
[data-theme="light"] .tl-table-head{background:#e8ecf4;}
[data-theme="light"] .tl-tr:hover{background:#e8ecf4;}
[data-theme="light"] .date-group-header{color:#1a2744;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .detail-header,[data-theme="light"] .profile-header,[data-theme="light"] .donors-section,[data-theme="light"] .bt-detail-header{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .acct-card{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .news-tab.active{color:#1a2744;border-color:#1a2744;}
[data-theme="light"] .story-source{color:#6b7280;}
[data-theme="light"] .profile-sidebar{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .home-title{color:#1a2744;}
[data-theme="light"] .cf-amount,[data-theme="light"] .cf-total{color:#1a2744;}
[data-theme="light"] .chamber-btn.active{background:rgba(26,39,68,0.1);color:#1a2744;border-color:rgba(26,39,68,0.3);}
[data-theme="light"] .swing-chip{background:rgba(26,39,68,0.1);color:#1a2744;}
[data-theme="light"] .score-cell.pass{background:rgba(37,107,66,0.12);}
[data-theme="light"] .score-cell.fail{background:rgba(176,48,32,0.08);}
[data-theme="light"] .map-tooltip-district{color:#1a2744;}
[data-theme="light"] .watchlist-btn-small,[data-theme="light"] .watch-btn{border-color:rgba(160,120,48,0.4);color:#a07830;}
[data-theme="light"] .vote-history-btn{background:#a07830;color:#fff;box-shadow:0 2px 8px rgba(160,120,48,0.3);}
[data-theme="light"] .masthead-badge{background:rgba(26,39,68,0.08);border-color:rgba(26,39,68,0.2);}
[data-theme="light"] .masthead-badge-dot{background:#1a2744;}
[data-theme="light"] .mast-btn.gold{border-color:rgba(160,120,48,0.4);color:#a07830;}
[data-theme="light"] .mast-btn.active{background:rgba(26,39,68,0.1);border-color:rgba(26,39,68,0.3);color:#1a2744;}
[data-theme="light"] .issue-tag{background:#e8ecf4;border-color:rgba(26,39,68,0.12);color:#1a1e2e;}
[data-theme="light"] .qp-btn{background:#f0f2f8;border-color:rgba(26,39,68,0.12);color:#6b7280;}
[data-theme="light"] .empty-card{background:#f0f2f8;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .donor-bar-fill{background:linear-gradient(90deg,#1a2744,#2d4a80);}
[data-theme="light"] .cf-leg-item.active,[data-theme="light"] .bt-bill-item.selected{border-left-color:#1a2744;}
[data-theme="light"] .subject-tag{background:#e8ecf4;border-color:rgba(26,39,68,0.12);color:#1a1e2e;}
[data-theme="light"] .plan-badge,[data-theme="light"] .admin{color:#1a2744;}
[data-theme="light"] .login-card{background:#f8f9fc;border-color:rgba(26,39,68,0.12);box-shadow:0 4px 24px rgba(26,39,68,0.1);}
`;

// --- AI RESPONSE GENERATOR ---


// ─── LEGISCAN INTEGRATION ─────────────────────────────────────────────────────
// Fetches real voting history per legislator on demand.
// Server-side: scans bills with votes and finds legislator in each roll call.
// Results cached in sessionStorage (24h) to avoid repeat queries.
// Attribution: Data provided by LegiScan (legiscan.com)

const PROXY_URL = "https://legisim-server.onrender.com";

function normalizeName(name) {
  return name.toLowerCase().replace(/[^a-z ]/g, "").trim();
}

// Fetch full voting history for a legislator (server does the heavy lifting)
async function fetchLegislatorVotes(legName, leg) {
  const cacheKey = "wc_votes_" + normalizeName(legName).replace(/ /g, "_");
  const cached = sessionStorage.getItem(cacheKey);
  // Only use cache if it has actual votes (don't serve stale empty results)
  if (cached) {
    const parsed = JSON.parse(cached);
    if (parsed && parsed.length > 0) return parsed;
  }

  try {
    // Pass chamber+district as hint to handle nickname mismatches (Jim vs James etc)
    const nameParam = leg ? legName + "|" + leg.chamber + "|" + leg.district : legName;
    const res = await fetch(PROXY_URL + "/api/db/personvotes?name=" + encodeURIComponent(nameParam));
    if (!res.ok) return null;
    const data = await res.json();
    if (data.error) return null;
    const votes = data.votes || [];
    // Cache by both input name and canonical name from server
    sessionStorage.setItem(cacheKey, JSON.stringify(votes));
    if (data.legislator) {
      const canonicalKey = "wc_votes_" + normalizeName(data.legislator).replace(/ /g, "_");
      sessionStorage.setItem(canonicalKey, JSON.stringify(votes));
    }
    return votes;
  } catch { return null; }
}

// Fetch how a specific legislator voted on a specific bill
// Used to answer direct questions like "How did Runestad vote on HB 4183?"
async function fetchBillVote(billNumber, legName) {
  const cacheKey = "wc_billvote_" + billNumber.replace(/\s/g, "") + "_" + normalizeName(legName).replace(/ /g, "_");
  const cached = sessionStorage.getItem(cacheKey);
  if (cached) return JSON.parse(cached);

  try {
    const res = await fetch(
      PROXY_URL + "/api/db/billvote?bill=" + encodeURIComponent(billNumber) +
      "&name=" + encodeURIComponent(legName)
    );
    if (!res.ok) return null;
    const data = await res.json();
    if (data.error) return null;
    sessionStorage.setItem(cacheKey, JSON.stringify(data));
    return data;
  } catch { return null; }
}

// Format votes for AI system prompt injection
function formatVotesForPrompt(votes) {
  if (!votes || votes.length === 0) return "";
  const recent = votes.slice(0, 100);
  const lines = recent.map(v => {
    const voteLabel = v.vote_text || (v.vote === 1 ? "Yea" : v.vote === 2 ? "Nay" : v.vote === 3 ? "Absent" : "NV");
    const outcome = v.passed ? "PASSED" : "FAILED";
    return "  " + (v.bill_number || "Bill") + " | " + voteLabel + " | " + (v.date || "") + " | " + (v.bill_title || v.description || "") + " [" + outcome + " " + (v.total_yea||0) + "-" + (v.total_nay||0) + "]";
  });
  const yeaCount = recent.filter(v => v.vote === 1 || (v.vote_text || "").toLowerCase() === "yea").length;
  const nayCount = recent.filter(v => v.vote === 2 || (v.vote_text || "").toLowerCase() === "nay").length;
  const partyLinePct = Math.round((yeaCount / (yeaCount + nayCount || 1)) * 100);
  return `
VERIFIED VOTING RECORD (LegiScan, 2025-2026 Session — ${recent.length} most recent votes):
Yea: ${yeaCount} | Nay: ${nayCount} | Yea rate: ${partyLinePct}%
${lines.join("\n")}`;
}

function buildSystemPrompt(leg, votingData = null) {
  const partyFull = leg.party === "D" ? "Democrat" : "Republican";
  const chamberTitle = leg.chamber === "Senate" ? "State Senator" : "State Representative";
  const ideologyDesc = leg.ideology <= 3 ? "strongly progressive" : leg.ideology <= 5 ? "moderate Democrat" : leg.ideology <= 7 ? "moderate Republican" : "strongly conservative";
  const lastName = leg.name.split(" ").pop();
  const title = leg.chamber === "Senate" ? "Sen." : "Rep.";

  // Full Michigan legislative context
  const legislativeContext = `MICHIGAN LEGISLATURE CONTEXT (2025-2026, 103rd Legislature):
Senate: 19 Democrats (majority), 18 Republicans, 1 Vacant. Majority Leader: Winnie Brinks (D-29). Minority Leader: Aric Nesbitt (R-20). President Pro Tem: Jeremy Moss (D-7).
House: 52 Democrats, 58 Republicans (majority). Speaker: Matt Hall (R-42). Majority Leader: Bryan Posthumus (R-90). Minority Leader: Ranjeev Puri (D-24).
Governor: Gretchen Whitmer (D) — divided government (D Senate, R House, D Governor).

KEY SENATE MEMBERS FOR CONTEXT:
Progressive Dems: Erika Geiss (SD1-Taylor), Sylvia Santana (SD2-Detroit), Stephanie Chang (SD3-Detroit), Jeff Irwin (SD15-Ann Arbor), Sarah Anthony (SD21-Lansing).
Moderate Dems: Darrin Camilleri (SD4-Brownstown), Dayna Polehanki (SD5-Livonia), Mary Cavanagh (SD6-Redford), Kevin Hertel (SD12-St. Clair Shores), Winnie Brinks (SD29-Grand Rapids), Sam Singh (SD28-East Lansing).
High-profile Dems: Jeremy Moss (SD7-Southfield, LGBTQ+ leader), Mallory McMorrow (SD8-Royal Oak, national profile).
Moderate Republicans: Michael Webber (SD9-Rochester Hills), Ruth Johnson (SD24-Holly), Mark Huizenga (SD30-Walker), John Damoose (SD37-Petoskey).
Conservative Republicans: Aric Nesbitt (SD20-Minority Leader), Thomas Albert (SD18-fiscal hawk), Lana Theis (SD22-Brighton), Jim Runestad (SD23-White Lake), Rick Outman (SD33-very conservative), Ed McBroom (SD38-UP).
Rural/Ag Republicans: Dan Lauwers (SD25-Thumb), Kevin Daley (SD26-Lapeer), Roger Victory (SD31-Ottawa), Jon Bumstead (SD32-Newaygo), Roger Hauck (SD34-Isabella).

KEY HOUSE MEMBERS FOR CONTEXT:
Speaker Matt Hall (R-42, Allegan/Kalamazoo). Majority Leader Bryan Posthumus (R-90, Kent). Minority Leader Ranjeev Puri (D-24, Wayne).
Southeast MI Dems (Wayne/Oakland/Macomb): Tyrone Carter (HD1), Tullio Liberati (HD2), Alabas Farhat (HD3), Karen Whitsett (HD4), Regina Weiss (HD5), Natalie Price (HD6), Tonya Myers Phillips (HD7), Helena Scott (HD8), Joe Tate (HD9), Veronica Paiz (HD10), Donavan McKinney (HD11), Kimberly Edwards (HD12), Mai Xiong (HD13), Mike McFall (HD14), Erin Byrnes (HD15), Stephanie Young (HD16), Laurie Pohutsky (HD17), Jason Hoskins (HD18), Samantha Steckloff (HD19), Noah Arbit (HD20), Kelly Breen (HD21), Matt Koleszar (HD22), Jason Morgan (HD23), Ranjeev Puri (HD24), Peter Herzberg (HD25), Dylan Wegela (HD26).
Suburban swing-area Republicans: Rylee Linting (HD27-Wayne), Jamie Thompson (HD28-Monroe/Wayne), Donni Steele (HD54-Oakland), Mark Tisdel (HD55-Oakland), Thomas Kuhn (HD57-Macomb/Oakland).
SW Michigan Republicans: Steve Carra (HD36), Brad Paquette (HD37), Pauline Wendzel (HD39), Matt Hall (HD42), Rachelle Smit (HD43), Steve Frisbie (HD44), Sarah Lightner (HD45), Kathy Schmaltz (HD46), Ann Bollin (HD49).
West Michigan Republicans: Bradley Slagh (HD85), Nancy De Boer (HD86), Greg VanWoerkom (HD88), Luke Meerman (HD89), Bryan Posthumus (HD90), Pat Outman (HD91), Jerry Neyer (HD92), Tim Kelly (HD93).
Mid/North Michigan Republicans: Bill G. Schuette (HD95), Timothy Beson (HD96), Matthew Bierlein (HD97), Gregory Alexander (HD98), Mike Hoadley (HD99), Tom Kunse (HD100), Joseph Fox (HD101), Curt VanderWall (HD102), John Roth (HD104), Ken Borton (HD105), Cam Cavitt (HD106), Parker Fairbairn (HD107), David Prestin (HD108), Karl Bohnak (HD109), Gregory Markkanen (HD110).
Competitive-district Dems: Reggie Miller (HD31-Lenawee/Monroe), Jimmie Wilson Jr. (HD32-Washtenaw), Morgan Foreman (HD33-Washtenaw), Joey Andrews (HD38-Allegan/Berrien), Matthew Longjohn (HD40-Kalamazoo), Julie Rogers (HD41-Kalamazoo), Carrie Rheingans (HD47-Jackson/Washtenaw), Jennifer Conlin (HD48-Jackson/Livingston), Brenda Carter (HD53-Oakland), Sharon MacDonell (HD56-Oakland), Denise Mentzer (HD61-Macomb), Betsy Coffia (HD103-N. Michigan).
Lansing-area Dems: Julie Brixie (HD73), Kara Hope (HD74), Penelope Tsernoglou (HD75), Angela Witwer (HD76), Emily Dievendorf (HD77).
Kent County Dems: Phil Skaggs (HD80), Stephen Wooden (HD81), Kristian Grant (HD82), John Fitzgerald (HD83-Minority Floor Leader), Carol Glanville (HD84).
Flint/Saginaw area: Jasper Martus (HD69-D), Cynthia Neeley (HD70-D), Amos O'Neal (HD94-D), Brian BeGole (HD71-R), Mike Mueller (HD72-R).`;

  return `You are WhipCount™, a Michigan legislative intelligence platform. You are providing expert predictive analysis focused on ${chamberTitle} ${leg.name} (${partyFull}, District ${leg.district}, ${leg.region}).

SUBJECT LEGISLATOR — FULL PROFILE:
Name: ${leg.name}
Title: ${chamberTitle}
Party: ${partyFull}
District: ${leg.district}
Region: ${leg.region}
Chamber: Michigan ${leg.chamber}
Ideology: ${ideologyDesc} (score ${leg.ideology}/10 from Progressive to Conservative)
Committees: ${leg.committees.join(', ')}
Key Issue Priorities: ${leg.keyIssues.join(', ')}
Background: ${leg.bio}
Data sources informing this profile: Bill sponsorship history, voting records, committee actions, public statements, press releases, campaign messaging, news coverage, interviews, social media posts, public financial disclosures, party caucus voting patterns.${votingData ? '\n' + votingData : ''}

${legislativeContext}

ANALYSIS RULES:
- You are a legislative intelligence analyst, NOT roleplaying as ${leg.name}.
- Speak analytically in third person: "${title} ${lastName} is likely to...", "Based on their record...", "Their district suggests..."
- Ground all analysis in ${leg.name}'s specific profile: their ideology, committees, key issues, region, and party context.
- When discussing strategy, reference real colleagues by name from the legislative context above.
- Use **bold** for key predictions, names, and vote estimates.
- Keep responses 150-300 words. Be specific and actionable.
- End strategic responses with a "**Persuasion note:**" line with the most effective framing for this legislator.
- Always note that outputs are probability estimates based on public record.`;
}

async function getAIResponse(leg, messages, userMessage, session) {
  const authHeader = session?.access_token ? { "Authorization": `Bearer ${session.access_token}` } : {};
  // Fetch real voting history and inject into system prompt
  const votes = await fetchLegislatorVotes(leg.name, leg);
  const votingData = formatVotesForPrompt(votes);

  // If user is asking about a specific bill, do a targeted lookup and prepend the result
  let billVoteContext = "";
  const billMatch = userMessage.match(/\b([HS]B\s*\d+|House Bill\s*\d+|Senate Bill\s*\d+)/i);
  if (billMatch) {
    const billNum = billMatch[1].replace(/\s+/g, "").toUpperCase();
    try {
      const bv = await fetchBillVote(billNum, leg.name);
      if (bv && bv.votes && bv.votes.length > 0) {
        const voteLines = bv.votes.map(v =>
          v.legislator_vote + " on \"" + (v.description || "floor vote") + "\" (" + v.date + ") — " +
          (v.passed ? "PASSED" : "FAILED") + " " + v.yea_total + "-" + v.nay_total
        ).join("; ");
        billVoteContext = "\n\nIMPORTANT — VERIFIED VOTE RECORD FROM LEGISCAN DATABASE:\n" +
          bv.bill_number + ": " + bv.bill_title + "\n" +
          leg.name + " voted " + bv.votes[0].legislator_vote.toUpperCase() + " on this bill.\n" +
          "Full record: " + voteLines + "\n" +
          "YOU MUST USE THIS DATA IN YOUR RESPONSE. Do not say you lack voting records.";
      } else if (bv && bv.message) {
        billVoteContext = "\n\nNOTE: Checked LegiScan database — " + billNum + " has no recorded roll call votes for " + leg.name + ".";
      } else {
        billVoteContext = "\n\nNOTE: Checked LegiScan database — could not retrieve vote data for " + billNum + ".";
      }
    } catch(e) {
      console.error("fetchBillVote error:", e);
    }
  }

  const systemPrompt = buildSystemPrompt(leg, votingData + billVoteContext);
  const apiMessages = [
    ...messages.filter(m => m.role !== "system").map(m => ({ role: m.role, content: m.content })),
    { role: "user", content: userMessage }
  ];

  const response = await fetch("https://legisim-server.onrender.com/api/chat", {
    method: "POST",
    headers: { "Content-Type": "application/json",
          ...authHeader },
    body: JSON.stringify({
      model: "claude-sonnet-4-20250514",
      max_tokens: 1000,
      system: systemPrompt,
      messages: apiMessages,
    }),
  });

  if (!response.ok) throw new Error(`Proxy error: ${response.status}`);
  const data = await response.json();
  return data.content?.map(c => c.text || "").join("") || "Unable to generate analysis.";
}

// --- COMPONENTS ---

function IdeologyBar({ score }) {
  const pct = ((score - 1) / 9) * 100;
  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", fontSize:"0.6rem", color:"var(--muted)", fontFamily:"var(--font-mono)", marginBottom:"0.3rem" }}>
        <span style={{ color:"var(--dem)" }}>Progressive</span>
        <span style={{ color:"var(--rep)" }}>Conservative</span>
      </div>
      <div className="ideology-bar">
        <div className="ideology-fill" style={{ width:`${pct}%` }} />
      </div>
    </div>
  );
}

function ProfileSidebar({ leg, photo, dirEntry }) {
  return (
    <div className="profile-sidebar">
      {photo && (
        <div style={{padding:"1.25rem 1.25rem 0",display:"flex",justifyContent:"center"}}>
          <img src={photo} alt={leg.name} style={{width:"100px",height:"100px",borderRadius:"50%",objectFit:"cover",border:"2px solid var(--border)"}} />
        </div>
      )}
      <div className="profile-section">
        <div className="profile-section-label">Background</div>
        <p>{leg.bio}</p>
      </div>
      {dirEntry && (dirEntry.phone || dirEntry.email || dirEntry.address) && (
        <div className="profile-section">
          <div className="profile-section-label">Contact</div>
          {dirEntry.phone && <div style={{fontFamily:"var(--font-mono)",fontSize:"0.7rem",color:"var(--muted)",marginBottom:"0.3rem"}}>📞 <a href={`tel:${dirEntry.phone}`} style={{color:"var(--gold)",textDecoration:"none"}}>{dirEntry.phone}</a></div>}
          {dirEntry.email && <div style={{fontFamily:"var(--font-mono)",fontSize:"0.7rem",color:"var(--muted)",marginBottom:"0.3rem",wordBreak:"break-all"}}>✉ <a href={`mailto:${dirEntry.email}`} style={{color:"var(--gold)",textDecoration:"none"}}>{dirEntry.email}</a></div>}
          {dirEntry.address && <div style={{fontFamily:"var(--font-mono)",fontSize:"0.65rem",color:"var(--muted)",lineHeight:1.5}}>{dirEntry.address}</div>}
        </div>
      )}
      <div className="profile-section">
        <div className="profile-section-label">Ideological Lean</div>
        <IdeologyBar score={leg.ideology} />
      </div>
      <div className="profile-section">
        <div className="profile-section-label">Key Issues</div>
        <div>{leg.keyIssues.map(i => <span key={i} className="issue-tag">{i}</span>)}</div>
      </div>
      <div className="profile-section">
        <div className="profile-section-label">Committees</div>
        {dirEntry?.notes && dirEntry.notes.includes('Committees:') ? (
          <div>{dirEntry.notes.split('Committees:')[1].trim().split(' | ').map(c => <span key={c} className="committee-tag">{c.trim()}</span>)}</div>
        ) : (
          <div>{leg.committees.map(c => <span key={c} className="committee-tag">{c}</span>)}</div>
        )}
      </div>
      <div className="profile-section">
        <div className="profile-section-label">Data Sources</div>
        <p style={{ fontSize:"0.72rem" }}>Bill sponsorship history · Voting records · Committee actions · Public statements · Campaign messaging · News coverage · Social media · Financial disclosures · Caucus patterns</p>
      </div>
    </div>
  );
}

function ChatPane({ leg, onViewVotes, session, queriesLeft, onQuerySent }) {
  const authHeader = session?.access_token ? { "Authorization": `Bearer ${session.access_token}` } : {};
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null);
  const inputRef = useRef(null);
  const lastName = leg.name.split(" ").pop();
  const title = leg.chamber === "Senate" ? "Sen." : "Rep.";
  const initials = leg.name.split(" ").map(n => n[0]).join("").slice(0,2);

  const QUICK_PROMPTS = [
    `How would ${title} ${lastName} respond to new infrastructure legislation?`,
    `What persuasion angle works best for ${title} ${lastName}?`,
    `Would ${title} ${lastName} sponsor a small business tax relief bill?`,
    `How does ${title} ${lastName} typically vote on environmental regulation?`,
    `What are ${title} ${lastName}'s biggest priorities this session?`,
  ];

  useEffect(() => {
    setMessages([]);
    setInput("");
  }, [leg.id]);

  useEffect(() => { if (bottomRef.current) bottomRef.current.scrollTop = 0; }, [messages]);

  const send = async (text) => {
    const userText = (text || input).trim();
    if (!userText || loading) return;
    if (queriesLeft <= 0) {
      setMessages(prev => [...prev, { role: "assistant", content: "⚠️ You've reached your 25 daily query limit. Your limit resets at midnight." }]);
      return;
    }
    setInput("");
    const userMsg = { role: "user", content: userText };
    setMessages(prev => [...prev, userMsg]);
    setLoading(true);
    try {
      if (session?.user?.id) {
        const newCount = await incrementQueryUsage(session.user.id);
        onQuerySent && onQuerySent(Math.max(0, DAILY_LIMIT - newCount));
      }
      const reply = await getAIResponse(leg, messages, userText, session);
      setMessages(prev => [...prev, { role: "assistant", content: reply }]);
    } catch (e) {
      setMessages(prev => [...prev, { role: "assistant", content: "Analysis unavailable. Please try again." }]);
    }
    setLoading(false);
  };

  const handleKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); }
  };

  const hasMessages = messages.length > 0;

  return (
    <div className="chat-pane">
      {!hasMessages ? (
        <div style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"2rem" }}>
          <div style={{ textAlign:"center", marginBottom:"1.5rem" }}>
            <div style={{ fontFamily:"var(--font-mono)", fontSize:"1.1rem", color:"var(--gold)", letterSpacing:"0.12em", marginBottom:"0.6rem" }}>WhipCount LEGISLATOR INTELLIGENCE</div>
            <div style={{ fontFamily:"var(--font-mono)", fontSize:"0.72rem", color:"var(--muted)", lineHeight:1.6 }}>
              Research tool powered by public voting records, bill history, and legislative data. Not affiliated with or representative of the legislator.
            </div>
            {onViewVotes && <button className="vote-history-btn" onClick={onViewVotes} style={{marginTop:"1rem"}}>📊 View Voting History</button>}
          </div>
          <div style={{ width:"100%", maxWidth:"620px" }}>
            <div style={{ display:"flex", gap:"0.75rem", alignItems:"flex-end" }}>
              <textarea
                ref={inputRef}
                className="chat-input"
                placeholder={`Ask about ${title} ${lastName}'s voting record, positions, or legislative history...`}
                value={input}
                onChange={e => setInput(e.target.value)}
                onKeyDown={handleKey}
                rows={2}
                style={{ borderRadius:"10px" }}
              />
              <button className="send-btn" onClick={() => send()} disabled={!input.trim() || loading}>
                {loading ? "…" : "Analyze →"}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="chat-notice" style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:"1rem"}}>
            <span><strong>Research tool:</strong> Outputs are generated from public legislative records and voting data. This is not a simulation of the legislator — outputs are analytical research, not statements from or about the individual.</span>
            {onViewVotes && <button className="vote-history-btn" onClick={onViewVotes}>📊 Voting History</button>}
          </div>
          <div className="chat-messages">
            {messages.map((m, i) => (
              <div key={i} className={`msg ${m.role === "user" ? "user" : ""}`}>
                <div className={`msg-avatar ${m.role === "user" ? "user" : `ai ${leg.party}`}`}>
                  {m.role === "user" ? "YOU" : initials}
                </div>
                <div>
                  <div className="msg-label">{m.role === "user" ? "Your query" : `WhipCount analysis — ${title} ${leg.name}`}</div>
                  <div className="msg-bubble" style={{ whiteSpace:"pre-wrap" }}>
                    {m.content.split(/\*\*(.*?)\*\*/g).map((part, pi) =>
                      pi % 2 === 1 ? <strong key={pi} style={{ color:"var(--gold)" }}>{part}</strong> : part
                    )}
                  </div>
                </div>
              </div>
            ))}
            {loading && (
              <div className="msg">
                <div className={`msg-avatar ai ${leg.party}`}>{initials}</div>
                <div>
                  <div className="msg-label">WhipCount analyzing...</div>
                  <div className="msg-bubble">
                    <span className="typing-dot" /><span className="typing-dot" /><span className="typing-dot" />
                  </div>
                </div>
              </div>
            )}
            <div ref={bottomRef} />
          </div>
          <div className="chat-input-area">
            <div className="chat-input-row">
              <textarea
                ref={inputRef}
                className="chat-input"
                placeholder={`Ask about ${title} ${lastName}'s voting record, positions, or legislative history...`}
                value={input}
                onChange={e => setInput(e.target.value)}
                onKeyDown={handleKey}
                rows={1}
              />
              <button className="send-btn" onClick={() => send()} disabled={!input.trim() || loading}>
                {loading ? "…" : "Analyze →"}
              </button>
            </div>
          </div>
        </>
      )}
      <div style={{textAlign:"center",fontFamily:"var(--font-mono)",fontSize:"0.6rem",fontWeight:700,color:queriesLeft <= 5 ? "#e05252" : "var(--muted)",padding:"0.3rem 0 0.5rem"}}>
        {queriesLeft}/{DAILY_LIMIT} queries remaining today
      </div>
    </div>
  );
}



// ─── VOTING HISTORY PANE ──────────────────────────────────────────────────────
// Fetches real voting record from LegiScan API via server proxy.
// Data source: LegiScan getPersonVotes endpoint
// Attribution: Data provided by LegiScan (legiscan.com)

// ── BILL CATEGORY ENGINE ─────────────────────────────────────────────────────
// Each category: { label, color, bg, border, keywords[] }
// color/bg/border are CSS rgba values for dark mode tints.
// Keywords matched case-insensitively against bill title.
// Order matters — first match wins. "Other" is the catch-all.
const BILL_CATEGORIES = [
  {
    key: "healthcare",
    label: "Healthcare",
    color: "rgba(52,211,153,1)",       // emerald
    bg:    "rgba(52,211,153,0.1)",
    border:"rgba(52,211,153,0.28)",
    keywords: ["health","hospital","medicaid","medicare","medical","mental health","behavioral health",
      "prescription","pharmacy","physician","nurse","nursing","dental","vision","insurance",
      "substance abuse","opioid","addiction","autism","disability","hospice","ambulance",
      "telehealth","public health","hiv","cancer","diabetes","disease","epidemic","vaccine",
      "immunization","wellness","behavioral","psychiatric","clinical"],
  },
  {
    key: "education",
    label: "Education",
    color: "rgba(96,165,250,1)",        // sky blue
    bg:    "rgba(96,165,250,0.1)",
    border:"rgba(96,165,250,0.28)",
    keywords: ["education","school","student","teacher","university","college","community college",
      "higher education","curriculum","literacy","tuition","scholarship","financial aid",
      "early childhood","preschool","kindergarten","library","charter school","graduation",
      "degree","academic","campus","classroom","faculty","k-12","school aid","stem","special education"],
  },
  {
    key: "taxes",
    label: "Taxes & Finance",
    color: "rgba(251,191,36,1)",        // amber
    bg:    "rgba(251,191,36,0.1)",
    border:"rgba(251,191,36,0.28)",
    keywords: ["tax","taxation","revenue","appropriation","budget","fiscal","income tax","sales tax",
      "property tax","millage","credit","deduction","exemption","treasury","debt","bond",
      "fund","grant","reimbursement","subsidy","refund","levy","assessment","finance",
      "surplus","deficit","pension","retirement fund","investment","auditor"],
  },
  {
    key: "criminal",
    label: "Criminal Justice",
    color: "rgba(248,113,113,1)",       // red
    bg:    "rgba(248,113,113,0.1)",
    border:"rgba(248,113,113,0.28)",
    keywords: ["criminal","crime","felony","misdemeanor","sentence","prison","jail","parole",
      "probation","police","law enforcement","sheriff","prosecutor","court","judge","jury",
      "juvenile","expunge","reentry","victim","assault","homicide","murder","theft","fraud",
      "trafficking","domestic violence","sexual","rape","firearm","weapon","gun","drug offense",
      "corrections","detention","incarceration","public safety","penalty","fine","bail"],
  },
  {
    key: "energy",
    label: "Energy & Environment",
    color: "rgba(74,222,128,1)",        // green
    bg:    "rgba(74,222,128,0.1)",
    border:"rgba(74,222,128,0.28)",
    keywords: ["energy","electricity","utility","electric","natural gas","renewable","solar","wind",
      "nuclear","coal","oil","pipeline","carbon","emission","climate","environment","pollution",
      "air quality","water quality","pfas","contamination","epa","egle","clean","conservation",
      "wildlife","forest","hunting","fishing","dnr","nature","recycling","waste","landfill",
      "compost","shoreline","wetland","habitat","biodiversity","michigan environment"],
  },
  {
    key: "transportation",
    label: "Transportation",
    color: "rgba(147,197,253,1)",       // light blue
    bg:    "rgba(147,197,253,0.09)",
    border:"rgba(147,197,253,0.28)",
    keywords: ["transportation","road","highway","bridge","infrastructure","transit","bus","rail",
      "railroad","airport","aviation","vehicle","motor","license","registration","speed limit",
      "traffic","driving","autonomous","electric vehicle","ev","bicycle","pedestrian","freight",
      "truck","mdot","local road","pothole","pavement","right of way","tollway","mobility"],
  },
  {
    key: "business",
    label: "Business & Labor",
    color: "rgba(251,146,60,1)",        // orange
    bg:    "rgba(251,146,60,0.1)",
    border:"rgba(251,146,60,0.28)",
    keywords: ["business","commerce","economic","economy","corporation","llc","employer","employee",
      "labor","worker","wage","minimum wage","overtime","union","collective bargaining","workforce",
      "job","employment","unemployment","small business","entrepreneur","startup","trade",
      "license","permit","regulation","industry","manufacturing","retail","franchise",
      "occupational","professional license","workers compensation","osha","medc","msp"],
  },
  {
    key: "housing",
    label: "Housing & Property",
    color: "rgba(196,181,253,1)",       // violet
    bg:    "rgba(196,181,253,0.09)",
    border:"rgba(196,181,253,0.26)",
    keywords: ["housing","home","homeowner","tenant","landlord","rent","eviction","mortgage",
      "property","real estate","zoning","land use","development","construction","building code",
      "affordable housing","shelter","homeless","foreclosure","deed","title","plat","easement",
      "condominium","apartment","mobile home","manufactured housing","fair housing","blight",
      "community development","neighborhood","urban renewal","mshda"],
  },
  {
    key: "agriculture",
    label: "Agriculture & Food",
    color: "rgba(163,230,53,1)",        // lime
    bg:    "rgba(163,230,53,0.09)",
    border:"rgba(163,230,53,0.26)",
    keywords: ["agriculture","farm","farmer","crop","livestock","dairy","poultry","beef","pork",
      "commodity","pesticide","herbicide","fertilizer","food","nutrition","hunger","snap",
      "ebt","food safety","food bank","restaurant","food service","grocery","rural","agri",
      "mda","michigan dept of agriculture","soil","irrigation","drainage","tile","commodity"],
  },
  {
    key: "elections",
    label: "Elections & Government",
    color: "rgba(129,140,248,1)",       // indigo
    bg:    "rgba(129,140,248,0.1)",
    border:"rgba(129,140,248,0.28)",
    keywords: ["election","vote","voter","ballot","campaign","candidate","redistrict","gerrymandering",
      "primary","general election","absentee","early voting","registration","clerk","secretary of state",
      "ethics","lobbying","lobbyist","campaign finance","transparency","disclosure","public record",
      "foia","open meetings","government","municipal","township","county","constitution","amendment",
      "term limit","legislature","legislator","bipartisan"],
  },
  {
    key: "children",
    label: "Children & Families",
    color: "rgba(249,168,212,1)",       // pink
    bg:    "rgba(249,168,212,0.09)",
    border:"rgba(249,168,212,0.26)",
    keywords: ["child","children","family","foster","adoption","parental","custody","juvenile",
      "youth","daycare","childcare","child welfare","dcwl","mdhhs","infant","baby","newborn",
      "maternity","paternity","domestic","marriage","divorce","guardianship","kin",
      "early intervention","nutrition","wic","snap","child support","abuse","neglect",
      "trafficking","runaway","homeless youth","after school"],
  },
  {
    key: "veterans",
    label: "Veterans & Military",
    color: "rgba(148,163,184,1)",       // slate
    bg:    "rgba(148,163,184,0.09)",
    border:"rgba(148,163,184,0.26)",
    keywords: ["veteran","military","armed forces","national guard","reserve","deployment","service member",
      "va benefit","gi bill","ptsd","veteran benefit","honor","memorial","medal","flag",
      "military base","fort","camp","defense","homeland security"],
  },
  {
    key: "hospitality",
    label: "Hospitality & Tourism",
    color: "rgba(253,186,116,1)",       // peach
    bg:    "rgba(253,186,116,0.09)",
    border:"rgba(253,186,116,0.26)",
    keywords: ["tourism","tourist","hotel","motel","lodging","hospitality","convention","resort",
      "recreation","golf","casino","gaming","lottery","liquor","alcohol","beer","wine","spirits",
      "bar","tavern","restaurant","food service","entertainment","event","festival","attraction",
      "trail","park","state park","campground","boating","snowmobile","atv","off-road",
      "travel","visit michigan","pure michigan","sport","sports","stadium","arena"],
  },
  {
    key: "technology",
    label: "Technology & Privacy",
    color: "rgba(34,211,238,1)",        // cyan
    bg:    "rgba(34,211,238,0.09)",
    border:"rgba(34,211,238,0.26)",
    keywords: ["technology","tech","internet","broadband","digital","data","privacy","cybersecurity",
      "artificial intelligence","ai","automated","software","computer","telecommunications",
      "cell","cellular","5g","fiber","surveillance","biometric","facial recognition",
      "social media","online","e-commerce","platform","algorithm","identity theft","cyber"],
  },
  {
    key: "civil",
    label: "Civil Rights & Social",
    color: "rgba(232,121,249,1)",       // fuchsia
    bg:    "rgba(232,121,249,0.09)",
    border:"rgba(232,121,249,0.26)",
    keywords: ["civil right","discrimination","equity","equality","race","racial","lgbtq","gender",
      "sex","harassment","hate crime","religion","religious freedom","abortion","reproductive",
      "human right","free speech","press","assembly","protest","immigration","refugee",
      "language","accessibility","ada","disability right","voting right"],
  },
  {
    key: "local",
    label: "Local Government",
    color: "rgba(110,231,183,1)",       // teal
    bg:    "rgba(110,231,183,0.09)",
    border:"rgba(110,231,183,0.26)",
    keywords: ["local government","municipality","township","city","village","county","charter",
      "ordinance","intergovernmental","home rule","annexation","authority","district","metro",
      "regional","public works","services","administration","officeholder","elected official",
      "assessor","treasurer","auditor","board","commission","council"],
  },
  {
    key: "courts",
    label: "Courts & Legal",
    color: "rgba(253,224,71,1)",        // yellow
    bg:    "rgba(253,224,71,0.09)",
    border:"rgba(253,224,71,0.26)",
    keywords: ["court","judicial","judge","attorney","lawyer","legal","lawsuit","litigation",
      "civil suit","statute","code","ordinance","appeals","supreme court","circuit court",
      "district court","probate","estate","trust","will","guardian","arbitration",
      "mediation","lien","contract","tort","liability","negligence","immunity"],
  },
  {
    key: "other",
    label: "Other",
    color: "rgba(156,163,175,1)",       // gray
    bg:    "rgba(156,163,175,0.08)",
    border:"rgba(156,163,175,0.22)",
    keywords: [], // catch-all
  },
];

function categorizeBill(title) {
  const t = (title || "").toLowerCase();
  for (const cat of BILL_CATEGORIES) {
    if (cat.key === "other") continue;
    if (cat.keywords.some(kw => t.includes(kw))) return cat.key;
  }
  return "other";
}

function VotingHistoryPane({ leg, onBack }) {
  const [voteFilter, setVoteFilter] = useState("all");
  const [catFilter, setCatFilter] = useState("all");
  const [voteSearch, setVoteSearch] = useState("");
  const [votes, setVotes] = useState([]);
  const [vhLoading, setVhLoading] = useState(true);
  const [vhError, setVhError] = useState(null);

  useEffect(() => {
    setVhLoading(true);
    setVhError(null);
    fetchLegislatorVotes(leg.name, leg)
      .then(rawVotes => {
        if (!rawVotes || rawVotes.length === 0) {
          setVhError("No voting data found for this legislator in LegiScan for the current session.");
          setVotes([]);
        } else {
          const mapped = rawVotes.map(v => {
            const title = v.bill_title || v.description || "—";
            return {
              bill_number: v.bill_number || "—",
              title,
              date: v.date || "—",
              vote: (function() {
                const vt = (v.vote_text || "").toLowerCase();
                if (vt === "yea" || v.vote === 1) return "yea";
                if (vt === "nay" || v.vote === 2) return "nay";
                if (vt === "absent" || v.vote === 4) return "absent";
                return "nv";
              })(),
              outcome: v.passed ? "passed" : "failed",
              yeas: v.total_yea || 0,
              nays: v.total_nay || 0,
              category: categorizeBill(title),
            };
          });
          setVotes(mapped);
        }
        setVhLoading(false);
      })
      .catch(err => {
        setVhError("Failed to load voting history: " + err.message);
        setVhLoading(false);
      });
  }, [leg.name]);

  // Build category counts from the full vote list (before category filter, so counts stay honest)
  const catCounts = {};
  votes.forEach(v => { catCounts[v.category] = (catCounts[v.category] || 0) + 1; });

  const filtered = votes.filter(v => {
    const matchVote = voteFilter === "all" || v.vote === voteFilter;
    const matchCat = catFilter === "all" || v.category === catFilter;
    const q = voteSearch.trim().toLowerCase();
    const matchSearch = !q ||
      v.bill_number.toLowerCase().includes(q) ||
      v.title.toLowerCase().includes(q) ||
      v.date.toLowerCase().includes(q) ||
      v.outcome.toLowerCase().includes(q);
    return matchVote && matchCat && matchSearch;
  });

  const yeaCount = votes.filter(v => v.vote === "yea").length;
  const nayCount = votes.filter(v => v.vote === "nay").length;
  const absentCount = votes.filter(v => v.vote === "absent" || v.vote === "nv").length;
  const yeaRate = votes.length > 0 ? Math.round(yeaCount / (yeaCount + nayCount || 1) * 100) : 0;
  const title = leg.chamber === "Senate" ? "Sen." : "Rep.";

  // Only show category pills that have at least 1 bill
  const activeCats = BILL_CATEGORIES.filter(c => c.key === "all" || (catCounts[c.key] || 0) > 0);

  return (
    <div className="vh-pane">
      <div className="vh-header">
        <div>
          <div className="vh-title">{title} {leg.name} — Voting Record</div>
          <div className="vh-subtitle">
            {vhLoading ? "Loading…" : `${votes.length} votes · District ${leg.district} · ${leg.region}`}
          </div>
        </div>
        <button className="vh-close" onClick={onBack}>← Back to Analysis</button>
      </div>

      {vhLoading && (
        <div className="vh-loading">
          <div className="vh-loading-ring" />
          Loading voting record from LegiScan…
        </div>
      )}

      {vhError && <div className="vh-error">{vhError}</div>}

      {!vhLoading && !vhError && (
        <>
          <div className="vh-stats">
            <div className="vh-stat">
              <div className="vh-stat-val yea">{yeaCount}</div>
              <div className="vh-stat-label">Yea</div>
            </div>
            <div className="vh-stat">
              <div className="vh-stat-val nay">{nayCount}</div>
              <div className="vh-stat-label">Nay</div>
            </div>
            <div className="vh-stat">
              <div className="vh-stat-val">{absentCount}</div>
              <div className="vh-stat-label">Absent / NV</div>
            </div>
            <div className="vh-stat">
              <div className="vh-stat-val">{yeaRate}%</div>
              <div className="vh-stat-label">Yea Rate</div>
            </div>
          </div>

          {/* Vote (Yea/Nay) filter row */}
          <div className="vh-filters">
            <span style={{ fontFamily:"var(--font-mono)", fontSize:"0.65rem", color:"var(--muted)", letterSpacing:"0.1em", flexShrink:0 }}>VOTE:</span>
            {[["all","All"],["yea","Yea"],["nay","Nay"],["absent","Absent"]].map(([key, label]) => (
              <button key={key} className={"vh-filter-btn" + (voteFilter === key ? " active" : "")} onClick={() => setVoteFilter(key)}>{label}</button>
            ))}
            <input
              value={voteSearch}
              onChange={e => setVoteSearch(e.target.value)}
              placeholder="Search bills…"
              style={{
                marginLeft:"auto",background:"var(--surface2)",border:"1px solid var(--border)",
                borderRadius:6,padding:"0.25rem 0.65rem",fontFamily:"var(--font-mono)",
                fontSize:"0.65rem",color:"var(--text)",outline:"none",width:"180px",
                transition:"border-color 0.18s"
              }}
              onFocus={e => e.target.style.borderColor="rgba(201,168,76,0.4)"}
              onBlur={e => e.target.style.borderColor="var(--border)"}
            />
          </div>

          {/* Thin separator */}
          <div className="vh-filter-row-sep" />

          {/* Category filter row */}
          <div className="vh-cat-filters">
            <button
              className={"vh-cat-btn" + (catFilter === "all" ? " active" : "")}
              onClick={() => setCatFilter("all")}
            >
              All
              <span className="vh-cat-count">{votes.length}</span>
            </button>
            {activeCats.filter(c => c.key !== "other" && c.key !== "all").map(cat => {
              const isActive = catFilter === cat.key;
              return (
                <button
                  key={cat.key}
                  data-cat={cat.key}
                  className={"vh-cat-btn" + (isActive ? " active" : "")}
                  onClick={() => setCatFilter(isActive ? "all" : cat.key)}
                >
                  {cat.label}
                  <span className="vh-cat-count">{catCounts[cat.key] || 0}</span>
                </button>
              );
            })}
            {(catCounts["other"] || 0) > 0 && (() => {
              const isActive = catFilter === "other";
              return (
                <button
                  data-cat="other"
                  className={"vh-cat-btn" + (isActive ? " active" : "")}
                  onClick={() => setCatFilter(isActive ? "all" : "other")}
                >
                  Other
                  <span className="vh-cat-count">{catCounts["other"]}</span>
                </button>
              );
            })()}
          </div>

          <div className="vh-list">
            {filtered.length === 0 && (
              <div style={{ padding:"2rem", textAlign:"center", fontFamily:"var(--font-mono)", fontSize:"0.7rem", color:"var(--muted)" }}>
                No votes match this filter.
              </div>
            )}
            {filtered.map((v, i) => {
              const catDef = BILL_CATEGORIES.find(c => c.key === v.category);
              return (
                <div key={i} className="vh-item">
                  <div className={"vh-vote-badge " + v.vote}>
                    {v.vote === "yea" ? "YEA" : v.vote === "nay" ? "NAY" : v.vote === "absent" ? "ABS" : "NV"}
                  </div>
                  <div className="vh-bill-number">{v.bill_number}</div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div className="vh-bill-title">{v.title}</div>
                    {catDef && catDef.key !== "other" && (
                      <span
                        className="vh-cat-chip"
                        style={{ background: catDef.bg, border:`1px solid ${catDef.border}`, color: catDef.color }}
                      >{catDef.label}</span>
                    )}
                  </div>
                  <div className="vh-bill-meta">
                    <div>{v.date}</div>
                    <div className={"vh-outcome " + v.outcome}>{v.outcome === "passed" ? "✓ Passed" : "✗ Failed"}</div>
                    <div style={{ fontSize:"0.56rem" }}>{v.yeas}–{v.nays}</div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="vh-source">Data provided by LegiScan (legiscan.com) · CC BY 4.0</div>
        </>
      )}
    </div>
  );
}

// --- GENERAL CHAT ---

const GENERAL_SYSTEM = `You are WhipCount™, a Michigan legislative intelligence platform. Answer questions about Michigan legislative dynamics, the Michigan Legislature, bill strategy, lobbying approaches, vote counting, committee processes, and political analysis. Be analytical, concise, and professional. Use **bold** for key insights. Keep responses 150-250 words.

IMPORTANT: When you receive verified vote data prefixed with "VERIFIED VOTE DATA:", treat it as ground truth and cite it directly in your response. Do not say you lack access to voting records when this data is provided.`;

const GENERAL_QUICK_PROMPTS = [
  "Which Michigan senators are most persuadable on business regulation?",
  "How does a bill move through Michigan Senate committees?",
  "What is the current balance of power in the Michigan Legislature?",
  "Which House members tend to break from their party caucus?",
];

function GeneralChat({ session, queriesLeft, onQuerySent }) {
  const authHeader = session?.access_token ? { "Authorization": `Bearer ${session.access_token}` } : {};
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => { if (bottomRef.current) bottomRef.current.scrollTop = 0; }, [messages]);

  const send = async (text) => {
    const userText = (text || input).trim();
    if (!userText || loading) return;
    if (queriesLeft <= 0) {
      setMessages(prev => [...prev, { role: "assistant", content: "⚠️ You've reached your 25 daily query limit. Your limit resets at midnight." }]);
      return;
    }
    setInput("");
    setMessages(prev => [...prev, { role: "user", content: userText }]);
    setLoading(true);
    if (session?.user?.id) {
      const newCount = await incrementQueryUsage(session.user.id);
      onQuerySent && onQuerySent(Math.max(0, DAILY_LIMIT - newCount));
    }
    try {
      // Check if user is asking about a specific bill vote for a specific legislator
      let voteContext = "";
      const billMatch = userText.match(/\b([HS]B\s*\d+|House Bill\s*\d+|Senate Bill\s*\d+)/i);
      // Extract legislator name — look for common patterns like "did [Name] vote" or "[Name]'s vote"
      // Match legislator name — handles full name, last name only, lowercase
      const legNameMatch = userText.match(/(?:did|how did|how has)\s+(?:sen\.?\s*|rep\.?\s*)?([A-Za-z]+(?:\s+[A-Za-z]+)*?)\s+(?:vote|voted)/i)
        || userText.match(/([A-Za-z]+(?:\s+[A-Za-z]+)*?)'s\s+vote/i);

      if (billMatch && legNameMatch) {
        const billNum = billMatch[1].replace(/\s+/g, "").toUpperCase();
        // Use the matched name as-is — server does fuzzy last-name matching
        const legName = legNameMatch[1].trim();
        try {
          const res = await fetch(
            "https://legisim-server.onrender.com/api/db/billvote?bill=" +
            encodeURIComponent(billNum) + "&name=" + encodeURIComponent(legName)
          );
          const bv = await res.json();
          if (bv && bv.votes && bv.votes.length > 0) {
            voteContext = "\n\nVERIFIED VOTE DATA FROM LEGISCAN DATABASE:\n" +
              bv.bill_number + ": " + bv.bill_title + "\n" +
              bv.legislator + " voted " + bv.votes[0].legislator_vote.toUpperCase() +
              " (" + bv.votes[0].date + ", " + (bv.votes[0].passed ? "PASSED" : "FAILED") +
              " " + bv.votes[0].yea_total + "-" + bv.votes[0].nay_total + ")\n" +
              "Source: LegiScan roll call data. Use this in your response.";
          }
        } catch(e) {}
      }

      const systemWithData = voteContext ? GENERAL_SYSTEM + voteContext : GENERAL_SYSTEM;
      const response = await fetch("https://legisim-server.onrender.com/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json",
          ...authHeader },
        body: JSON.stringify({
          model: "claude-haiku-4-5-20251001",
          max_tokens: 1000,
          system: systemWithData,
          messages: [...messages, { role: "user", content: userText }],
        }),
      });
      const data = await response.json();
      const reply = data.content?.map(c => c.text || "").join("") || "Analysis unavailable.";
      setMessages(prev => [...prev, { role: "assistant", content: reply }]);
    } catch {
      setMessages(prev => [...prev, { role: "assistant", content: "Analysis unavailable. Please try again." }]);
    }
    setLoading(false);
  };

  const handleKey = (e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } };

  const hasMessages = messages.length > 0;

  return (
    <div className="chat-pane" style={{ position:"relative" }}>
      {/* Centered input when no messages */}
      {!hasMessages ? (
        <div style={{
          flex:1, display:"flex", flexDirection:"column",
          alignItems:"center", justifyContent:"center", padding:"2rem",
        }}>
          <div style={{ textAlign:"center", marginBottom:"1.5rem" }}>
            <div style={{ fontFamily:"var(--font-mono)", fontSize:"1.1rem", color:"var(--gold)", letterSpacing:"0.12em", marginBottom:"0.6rem" }}>WhipCount LEGISLATIVE INTELLIGENCE</div>
            <div style={{ fontFamily:"var(--font-mono)", fontSize:"0.72rem", color:"var(--muted)", lineHeight:1.6 }}>
              Ask about Michigan legislative strategy, voting patterns, bill pathways, or select a legislator for a detailed research profile.
            </div>
          </div>
          <div style={{ width:"100%", maxWidth:"620px" }}>
            <div style={{ display:"flex", gap:"0.75rem", alignItems:"flex-end" }}>
              <textarea
                className="chat-input"
                placeholder="Ask about Michigan legislative strategy, committee dynamics, vote counts, or lobbying approach…"
                value={input}
                onChange={e => setInput(e.target.value)}
                onKeyDown={handleKey}
                rows={2}
                style={{ borderRadius:"10px" }}
              />
              <button className="send-btn" onClick={() => send()} disabled={!input.trim() || loading}>
                {loading ? "…" : "Analyze →"}
              </button>
            </div>
          </div>
        </div>
      ) : (
        /* Normal scrolling chat once messages exist */
        <>
          <div className="chat-notice">
            <strong>Research tool:</strong> Outputs are generated from public legislative data. Select a legislator from the left panel for a detailed profile powered by live voting records.
          </div>
          <div className="chat-messages">
            {messages.map((m, i) => (
              <div key={i} className={`msg ${m.role === "user" ? "user" : ""}`}>
                <div className={`msg-avatar ${m.role === "user" ? "user" : "ai D"}`}>
                  {m.role === "user" ? "YOU" : "LS"}
                </div>
                <div>
                  <div className="msg-label">{m.role === "user" ? "Your query" : "WhipCount Analysis"}</div>
                  <div className="msg-bubble" style={{ whiteSpace:"pre-wrap" }}>
                    {m.content.split(/\*\*(.*?)\*\*/g).map((part, pi) =>
                      pi % 2 === 1 ? <strong key={pi} style={{ color:"var(--gold)" }}>{part}</strong> : part
                    )}
                  </div>
                </div>
              </div>
            ))}
            {loading && (
              <div className="msg">
                <div className="msg-avatar ai D">LS</div>
                <div>
                  <div className="msg-label">WhipCount analyzing...</div>
                  <div className="msg-bubble">
                    <span className="typing-dot" /><span className="typing-dot" /><span className="typing-dot" />
                  </div>
                </div>
              </div>
            )}
            <div ref={bottomRef} />
          </div>
          <div className="chat-input-area">
            <div className="chat-input-row">
              <textarea
                className="chat-input"
                placeholder="Ask about Michigan legislative strategy, committee dynamics, vote counts, or lobbying approach…"
                value={input}
                onChange={e => setInput(e.target.value)}
                onKeyDown={handleKey}
                rows={1}
              />
              <button className="send-btn" onClick={() => send()} disabled={!input.trim() || loading}>
                {loading ? "…" : "Analyze →"}
              </button>
            </div>
          </div>
        </>
      )}
      <div style={{textAlign:"center",fontFamily:"var(--font-mono)",fontSize:"0.6rem",fontWeight:700,color:queriesLeft <= 5 ? "#e05252" : "var(--muted)",padding:"0.3rem 0 0.5rem"}}>
        {queriesLeft}/{DAILY_LIMIT} queries remaining today
      </div>
    </div>
  );
}

// --- MAIN APP ---

async function handleSignOut(supabaseClient, onNavigate) {
  await supabaseClient.auth.signOut();
  onNavigate('home');
}

export default function WhipCountPlatform({ onNavigate, session, profile }) {
  const [selected, setSelected] = useState(null);
  const [queriesLeft, setQueriesLeft] = useState(DAILY_LIMIT);
  const { toasts, toast, dismiss } = useToast();
  // dirMap stores full directory entries keyed by lowercase name
  const [dirMap, setDirMap] = useState({});

  useEffect(() => {
    if (session?.user?.id && profile?.role !== "admin") {
      getQueryUsage(session.user.id).then(count => {
        setQueriesLeft(Math.max(0, DAILY_LIMIT - count));
      });
    }
  }, [session]);

  useEffect(() => {
    fetch("https://legisim-server.onrender.com/api/directory?category=Legislature")
      .then(r => r.json())
      .then(d => {
        const map = {};
        (d.entries || []).forEach(e => { map[e.name.toLowerCase()] = e; });
        setDirMap(map);
      })
      .catch(() => {});
  }, []);

  const getDirEntry = (name) => {
    if (!name) return null;
    const lower = name.toLowerCase();
    if (dirMap[lower]) return dirMap[lower];
    const last = lower.split(" ").pop();
    return Object.values(dirMap).find(e => e.name.toLowerCase().includes(last)) || null;
  };

  const getPhoto = (name) => getDirEntry(name)?.photo_url || null;
  const [search, setSearch] = useState("");
  const [chamberFilter, setChamberFilter] = useState("All");
  const [partyFilter, setPartyFilter] = useState("All");
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(true);
  const [viewMode, setViewMode] = useState("chat"); // "chat" or "votes"

  const filtered = ALL_LEGISLATORS.filter(l => {
    const q = search.toLowerCase();
    const matchSearch = !q || l.name.toLowerCase().includes(q) || l.region.toLowerCase().includes(q) || String(l.district).includes(q);
    const matchChamber = chamberFilter === "All" || l.chamber === chamberFilter;
    const matchParty = partyFilter === "All" || l.party === partyFilter;
    return matchSearch && matchChamber && matchParty;
  });

  const featured = ALL_LEGISLATORS.filter(l => ["Mallory McMorrow","Winnie Brinks","Aric Nesbitt","Matt Hall"].includes(l.name));

  return (
    <div className="app">
      <style>{CSS}</style>
        <MobileMenuCSS />
        {/* MASTHEAD */}
        <div className="legisim-masthead">
          <div className="masthead-left">
            <div className="masthead-wordmark">Whip<em>Count</em><sup>TM</sup></div>
            <button className="mast-back" onClick={() => onNavigate("dashboard")}>← Dashboard</button>
          </div>
          <div className="masthead-right">
            <button className="mast-btn-sm" onClick={() => onNavigate("account")}>Account</button>
            <button className="mast-btn-sm signout" onClick={() => handleSignOut(supabase, onNavigate)}>Sign Out</button>
          </div>
        </div>
        <div className="app-body">
        {/* Mobile sidebar overlay — closes sidebar when tapping outside */}
        {mobileSidebarOpen && (
          <div
            onClick={() => setMobileSidebarOpen(false)}
            className="mobile-sidebar-overlay"
          />
        )}
        {/* SIDEBAR */}
        <div className={`sidebar${mobileSidebarOpen ? " mobile-open" : ""}`}>
          {/* Collapsed strip */}
          <div className="sidebar-collapsed">
            <div className="collapsed-search" title="Hover to search legislators">
              <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/></svg>
            </div>
            <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center" }}>
              <div style={{
                fontFamily:"var(--font-mono)", fontSize:"0.65rem", fontWeight:600,
                color:"var(--muted)", letterSpacing:"0.2em", textTransform:"uppercase",
                writingMode:"vertical-rl", textOrientation:"mixed",
                transform:"rotate(180deg)", userSelect:"none",
              }}>
                Legislator Search
              </div>
            </div>
          </div>
          {/* Expanded panel */}
          <div className="sidebar-inner">
          <div className="sidebar-header">
            <div className="logo-sub">Legislator Search</div>
          </div>
          <div className="search-area">
            <input
              className="search-input"
              placeholder="Search legislator, district, region…"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            <div className="filters">
              {["All","Senate","House"].map(f => (
                <button key={f} className={`filter-btn ${chamberFilter === f ? "active" : ""}`} onClick={() => setChamberFilter(f)}>{f}</button>
              ))}
              <button className={`filter-btn ${partyFilter === "D" ? "dem-active" : ""}`} onClick={() => setPartyFilter(p => p === "D" ? "All" : "D")}>Democrat</button>
              <button className={`filter-btn ${partyFilter === "R" ? "rep-active" : ""}`} onClick={() => setPartyFilter(p => p === "R" ? "All" : "R")}>Republican</button>
            </div>
          </div>
          <div className="list-meta">{filtered.length} legislator{filtered.length !== 1 ? "s" : ""} · {filtered.filter(l=>l.party==="D").length}D / {filtered.filter(l=>l.party==="R").length}R</div>
          <div className="leg-list">
            {filtered.map(leg => {
              const initials = leg.name.split(" ").map(n => n[0]).join("").slice(0,2);
              return (
                <div key={leg.id} className={`leg-item ${selected?.id === leg.id ? "selected" : ""}`} onClick={() => { setSelected(leg); setViewMode("chat"); if (window.innerWidth <= 768) setMobileSidebarOpen(false); }}>
                  {(() => { const photo = getPhoto(leg.name); return photo
                    ? <img src={photo} alt={leg.name} style={{width:"36px",height:"36px",borderRadius:"50%",objectFit:"cover",flexShrink:0}} />
                    : <div className={`leg-avatar ${leg.party}`}>{initials}</div>; })()}
                  <div style={{ flex:1, minWidth:0 }}>
                    <div className="leg-name">{leg.name}</div>
                    <div className="leg-meta">{leg.chamber} · D{leg.district} · {leg.region.split('/')[0]}</div>
                  </div>
                  <span className={`leg-badge ${leg.party}`}>{leg.party === "D" ? "DEM" : "REP"}</span>
                </div>
              );
            })}
            {filtered.length === 0 && (
              <div style={{ padding:"2rem 1.25rem", textAlign:"center", color:"var(--muted)", fontSize:"0.82rem" }}>No legislators match your search.</div>
            )}
          </div>
          </div>
        </div>

        {/* MAIN */}
        <div className="main">
          {/* Mobile toggle to open sidebar */}
          <button
            className="mobile-sidebar-toggle"
            style={{display: "none"}}
            onClick={() => setMobileSidebarOpen(true)}
            id="mobile-sidebar-toggle-btn"
          >
            👥 Browse Legislators
          </button>
          <style>{`@media(max-width:768px){#mobile-sidebar-toggle-btn{display:flex !important;}}`}</style>
          {selected ? (
            <>
              <div className="main-topbar">
                <div className="topbar-left">
                  {(() => { const photo = getPhoto(selected.name); return photo
                    ? <img src={photo} alt={selected.name} style={{width:"32px",height:"32px",borderRadius:"50%",objectFit:"cover",flexShrink:0}} />
                    : <div className={`topbar-avatar ${selected.party}`}>{selected.name.split(" ").map(n=>n[0]).join("").slice(0,2)}</div>; })()}
                  <div>
                    <div className="topbar-name">{selected.name}</div>
                    <div className="topbar-sub">{selected.chamber === "Senate" ? "State Senator" : "State Representative"} · District {selected.district} · {selected.region}</div>
                  </div>
                </div>
                <div className="topbar-badges">
                  <span className={`badge-chip ${selected.party}`}>{selected.party === "D" ? "Democrat" : "Republican"}</span>
                  <span className="badge-chip">{selected.chamber}</span>
                  <span className="badge-chip">Dist. {selected.district}</span>
                  <button
                    onClick={() => { setSelected(null); setViewMode("chat"); }}
                    style={{ marginLeft:"0.75rem", background:"var(--card)", border:"1px solid var(--gold-dim)", borderRadius:"6px", padding:"0.35rem 0.9rem", color:"var(--gold)", fontFamily:"var(--font-mono)", fontSize:"0.7rem", cursor:"pointer", letterSpacing:"0.06em", transition:"all 0.18s", fontWeight:600 }}
                    onMouseOver={e => { e.target.style.background="var(--gold)"; e.target.style.color="#09090e"; }}
                    onMouseOut={e => { e.target.style.background="var(--card)"; e.target.style.color="var(--gold)"; }}
                  >← General Chat</button>
                </div>
              </div>
              <div className="profile-pane">
                <ProfileSidebar leg={selected} photo={getPhoto(selected.name)} dirEntry={getDirEntry(selected.name)} />
                {viewMode === "votes"
                  ? <VotingHistoryPane key={selected.id + "-votes"} leg={selected} onBack={() => setViewMode("chat")} />
                  : <ChatPane key={selected.id} leg={selected} onViewVotes={() => setViewMode("votes")} session={session} queriesLeft={queriesLeft} onQuerySent={setQueriesLeft} />
                }
              </div>
            </>
          ) : (
            <>
              <div className="main-topbar">
                <div>
                  <div style={{ fontFamily:"var(--font-display)", fontSize:"1rem", fontWeight:700 }}>WhipCount™ — General Analysis</div>
                  <div style={{ fontFamily:"var(--font-mono)", fontSize:"0.65rem", color:"var(--muted)" }}>Ask a general question, or select a legislator from the list for a targeted profile</div>
                </div>


              </div>
              <GeneralChat session={session} queriesLeft={queriesLeft} onQuerySent={setQueriesLeft} />
            </>
          )}
        </div>{/* end main */}
        </div>{/* end app-body */}
      <ToastContainer toasts={toasts} dismiss={dismiss} />
    </div>
  );
}
